// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Tokens — Open WebUI gray scale (oklch → hex)
 * gray-800 #333  gray-850 #262626  gray-900 #171717  gray-950 #0d0d0d
 * spacing = 0.25rem  radius-2xl=1rem  radius-3xl=1.5rem  radius-4xl=2rem
 * text-sm=0.875rem  text-base=1rem  leading-relaxed=1.625
 */
:root {
    --g800: #333333;
    --g850: #262626;
    --g900: #171717;
    --g950: #0d0d0d;
    --t1: #f5f5f5;      /* text primary */
    --t2: #a3a3a3;      /* text secondary */
    --t3: #737373;      /* text muted/placeholder */
    --bd: rgba(255,255,255,0.08);   /* border normal */
    --bd2: rgba(255,255,255,0.14);  /* border stronger */
    --r2xl: 1rem;
    --r3xl: 1.5rem;
    --r4xl: 2rem;
    --acc: #3b82f6;
    --sky: #0ea5e9;     /* sky-500 for follow-up links */
    --font: "Inter", "Segoe UI", ui-sans-serif, system-ui, -apple-system, sans-serif;
}

/* ── Reset ──────────────────────────────────────────────── */
html, body {
    width: 100%; height: 100%;
    margin: 0; padding: 0;
    background: var(--g900);
    color: var(--t1);
    font-family: var(--font);
    font-size: 1rem;           /* text-base = 16px */
    line-height: 1.625;        /* leading-relaxed */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
*, *::before, *::after { box-sizing: border-box; }
button, textarea, input { font: inherit; color: inherit; }
button { cursor: pointer; background: none; border: none; padding: 0; }
#container { width: 100%; height: 100%; }

/* ── App shell ──────────────────────────────────────────── */
.taskpane-app {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: var(--g900);
    overflow: hidden;
}
.taskpane-spacer { flex: 1 1 auto; }

/* ── App-Root: Chat + (optional) Vorschlags-Panel rechts daneben ───────── */
.app-root { display: flex; width: 100%; height: 100%; overflow: hidden; }
.app-root__main { flex: 1 1 auto; min-width: 0; height: 100%; display: flex; }

/* ── Änderungsvorschläge — Seitenpanel rechts ──────────────────────────── */
.change-proposal-panel {
    flex: 0 0 clamp(15rem, 42%, 22rem);
    display: flex; flex-direction: column;
    height: 100%;
    background: var(--g950);
    border-left: 1px solid var(--bd2);
    overflow: hidden;
}
.change-proposal-panel__header {
    flex: 0 0 auto;
    padding: .625rem .75rem;
    border-bottom: 1px solid var(--bd);
    display: flex; align-items: center; justify-content: space-between; gap: .5rem;
}
.change-proposal-panel__mode { flex: 0 0 auto; }
.change-proposal-panel__mode-select {
    background: var(--g800); color: var(--t2);
    border: 1px solid var(--bd2); border-radius: .375rem;
    font-size: .6875rem; padding: .15rem .35rem; max-width: 11rem;
}
.change-proposal-panel__title { font-size: .8125rem; font-weight: 600; color: var(--t1); }

.change-proposal-panel__list {
    flex: 1 1 auto; overflow-y: auto;
    list-style: none; margin: 0; padding: .5rem;
    display: flex; flex-direction: column; gap: .5rem;
}
.change-proposal-panel__item {
    border: 1px solid var(--bd); border-radius: .5rem;
    background: var(--g900);
    padding: .5rem .625rem;
    display: flex; flex-direction: column; gap: .375rem;
}
.change-proposal-panel__item-head {
    display: flex; align-items: center; gap: .375rem;
    width: 100%; text-align: left; cursor: pointer;
    border-radius: .25rem; transition: opacity .12s;
}
.change-proposal-panel__item-head:hover { opacity: .75; }
.change-proposal-panel__op-badge {
    font-size: .625rem; font-weight: 600; text-transform: uppercase; letter-spacing: .03em;
    padding: .125rem .375rem; border-radius: .25rem;
    background: rgba(59,130,246,.15); color: #93c5fd;
}
.change-proposal-panel__para { font-size: .6875rem; color: var(--t3); }

.change-proposal-panel__before,
.change-proposal-panel__after { display: flex; flex-direction: column; gap: .125rem; }
.change-proposal-panel__label { font-size: .625rem; text-transform: uppercase; letter-spacing: .03em; color: var(--t3); }
.change-proposal-panel__text {
    font-size: .8125rem; line-height: 1.35; white-space: pre-wrap; word-break: break-word;
    border-radius: .25rem; padding: .25rem .375rem;
}
.change-proposal-panel__text--old { background: rgba(239,68,68,.12); color: #fca5a5; text-decoration: line-through; }
.change-proposal-panel__text--new { background: rgba(34,197,94,.12); color: #86efac; }
.change-proposal-panel__comment { font-size: .75rem; color: var(--t2); font-style: italic; }

.change-proposal-panel__actions { display: flex; gap: .375rem; margin-top: .125rem; }
.change-proposal-panel__btn {
    font-size: .75rem; font-weight: 500; padding: .3rem .5rem; border-radius: .375rem;
    border: 1px solid var(--bd2); color: var(--t1); background: transparent; transition: background .12s, filter .12s;
}
.change-proposal-panel__btn:hover { background: rgba(255,255,255,.07); }
.change-proposal-panel__btn--accept { flex: 1 1 auto; border-color: rgba(34,197,94,.4); color: #86efac; }
.change-proposal-panel__btn--accept:hover { background: rgba(34,197,94,.12); }
.change-proposal-panel__btn--reject { flex: 1 1 auto; border-color: rgba(239,68,68,.4); color: #fca5a5; }
.change-proposal-panel__btn--reject:hover { background: rgba(239,68,68,.12); }

.change-proposal-panel__bulk-actions {
    flex: 0 0 auto; display: flex; gap: .5rem;
    padding: .625rem .75rem; border-top: 1px solid var(--bd);
}
.change-proposal-panel__btn--accept-all,
.change-proposal-panel__btn--reject-all { flex: 1 1 auto; }
.change-proposal-panel__btn--accept-all { background: var(--acc); border-color: var(--acc); color: #fff; }
.change-proposal-panel__btn--accept-all:hover { filter: brightness(1.1); }

/* Auflösungs-Status eines Vorschlags (in der Sidebar) */
.change-proposal-panel__status { font-size: .6875rem; padding: .125rem 0; }
.change-proposal-panel__status--applied { color: #86efac; }
.change-proposal-panel__status--rejected { color: #fca5a5; }
.change-proposal-panel__item--applied { opacity: .72; }
.change-proposal-panel__item--rejected { opacity: .55; }

/* ── Änderungsvorschläge-Sidebar (rechts; gegenseitig exklusiv zur History) ── */
.cp-sidebar {
    width: 260px;
    background: #0f0f0f;
    border-left: 1px solid var(--bd2);
    display: flex; flex-direction: column; min-height: 0;
}
.cp-sidebar--docked { flex: 0 0 260px; }
.cp-sidebar--overlay {
    position: absolute; top: 0; right: 0; bottom: 0;
    z-index: 30; box-shadow: -8px 0 24px rgba(0,0,0,.45);
}
.cp-sidebar__header {
    flex: 0 0 auto; display: flex; align-items: center; justify-content: space-between;
    padding: .625rem .75rem .5rem;
}
.cp-sidebar__title { font-size: .8125rem; font-weight: 600; color: var(--t1); }
.cp-sidebar__mode { display: block; padding: 0 .75rem .5rem; }
.cp-sidebar__mode-select {
    width: 100%; font-size: .75rem; padding: .25rem .375rem; border-radius: .375rem;
    background: var(--g850); color: var(--t1); border: 1px solid var(--bd);
}
.cp-sidebar__body {
    flex: 1 1 auto; min-height: 0; overflow-y: auto; padding: .25rem .5rem .5rem;
    scrollbar-width: thin;
    scrollbar-color: rgba(255,255,255,.1) transparent;
}
.cp-sidebar__body::-webkit-scrollbar       { width: .3rem; }
.cp-sidebar__body::-webkit-scrollbar-track { background: transparent; }
.cp-sidebar__body::-webkit-scrollbar-thumb { background: rgba(255,255,255,.1); border-radius: 999px; }
.cp-sidebar__bulk {
    flex: 0 0 auto; display: flex; gap: .375rem;
    padding: .5rem .625rem .625rem; border-top: 1px solid var(--bd);
}

/* ── Einzelner Vorschlag (Sidebar-Item) ──────────────────────────────────── */
.cp-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: .5rem; }
.cp-item {
    display: flex; flex-direction: column; gap: .25rem;
    padding: .5rem .5rem .5rem .625rem; border-radius: .5rem;
    background: var(--g850); border: 1px solid var(--bd);
    transition: opacity .15s ease;
}
.cp-item--applied { opacity: .72; }
.cp-item--rejected { opacity: .55; }
.cp-item__head { display: flex; align-items: center; gap: .375rem; }
.cp-item__num { font-size: .75rem; font-weight: 600; color: var(--t1); }
.cp-item__jump {
    font-size: .6875rem; color: var(--t3); padding: 0 .125rem; border-radius: .25rem;
}
.cp-item__jump:hover { color: var(--t1); }
.cp-item__spacer { flex: 1 1 auto; }
.cp-item__chevron {
    flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
    width: 1.25rem; height: 1.25rem; border-radius: .25rem; color: var(--t2);
}
.cp-item__chevron:hover { background: rgba(255,255,255,.07); color: var(--t1); }
.cp-item__chevron-icon { transition: transform .15s ease; }
.cp-item__chevron-icon--open { transform: rotate(180deg); }

/* ── Changes-Bullet unter der Assistant-Nachricht (wie eine Quellenangabe) ── */
.changes-bullet-row { margin-top: .5rem; }
.changes-bullet {
    display: inline-flex; align-items: center; gap: .375rem;
    padding: .25rem .5rem; border-radius: .5rem;
    border: 1px solid var(--bd); background: var(--g850); color: var(--t2);
    font-size: .75rem;
}
.changes-bullet--blink { animation: changes-bullet-blink 1.4s ease-in-out 2; }
.changes-bullet:hover { background: rgba(255,255,255,.06); color: var(--t1); }
.changes-bullet__icon { flex: 0 0 auto; }
.changes-bullet__count { font-weight: 500; }
.changes-bullet__badge {
    font-size: .625rem; padding: .0625rem .25rem; border-radius: .375rem;
    background: rgba(255,255,255,.08); color: var(--t2);
}
.changes-bullet__badge--done { background: rgba(34,197,94,.18); color: #86efac; }
@keyframes changes-bullet-blink {
    0%, 100% { box-shadow: 0 0 0 0 rgba(59,130,246,0); border-color: var(--bd); }
    50%      { box-shadow: 0 0 0 3px rgba(59,130,246,.35); border-color: var(--acc); }
}

/* ── Quellen-Picker + Wissensquellen-Overlay ───────────────────────────── */
.composer { position: relative; }
.composer__source-picker-overlay {
    position: absolute;
    left: 1rem; right: 1rem;
    bottom: calc(100% - .25rem);
    z-index: 200;
}
.source-picker {
    background: var(--g850);
    border: 1px solid var(--bd2);
    border-radius: var(--r2xl);
    box-shadow: 0 8px 24px rgba(0,0,0,.5);
    display: flex; flex-direction: column;
    max-height: 60vh; overflow: hidden;
}
.source-picker__header {
    display: flex; align-items: center; gap: .5rem;
    padding: .5rem .625rem; border-bottom: 1px solid var(--bd);
    font-size: .8125rem; font-weight: 600; color: var(--t1);
}
.source-picker__header span { flex: 1 1 auto; }
.source-picker__menu { display: flex; flex-direction: column; padding: .375rem; gap: .125rem; }
.source-picker__item {
    text-align: left; padding: .5rem .625rem; border-radius: .5rem;
    font-size: .875rem; color: var(--t1);
}
.source-picker__item:hover { background: rgba(255,255,255,.07); }

.source-picker__body { padding: .625rem; display: flex; flex-direction: column; gap: .5rem; }
.source-picker__url-input,
.source-picker__search {
    width: 100%; box-sizing: border-box;
    padding: .5rem .625rem; border-radius: .5rem;
    background: var(--g900); border: 1px solid var(--bd2); color: var(--t1);
    font-size: .875rem;
}
.source-picker__search-row { padding: .5rem .625rem 0; }

.source-picker__kb-list {
    flex: 1 1 auto; overflow-y: auto;
    padding: .5rem; display: flex; flex-direction: column; gap: .375rem;
}
.source-picker__kb-item {
    display: flex; align-items: flex-start; gap: .5rem;
    text-align: left; padding: .5rem .625rem; border-radius: .5rem;
    border: 1px solid var(--bd); background: var(--g900);
}
.source-picker__kb-item:hover { background: rgba(255,255,255,.05); }
.source-picker__kb-item--selected { border-color: var(--acc); background: rgba(59,130,246,.12); }
.source-picker__kb-check {
    flex: 0 0 1rem; width: 1rem; height: 1rem; margin-top: .1rem;
    display: inline-flex; align-items: center; justify-content: center;
    border-radius: .25rem; border: 1px solid var(--bd2);
    font-size: .6875rem; color: #fff;
}
.source-picker__kb-item--selected .source-picker__kb-check { background: var(--acc); border-color: var(--acc); }
.source-picker__kb-body { display: flex; flex-direction: column; gap: .125rem; min-width: 0; }
.source-picker__kb-name { font-size: .8125rem; font-weight: 500; color: var(--t1); }
.source-picker__kb-desc {
    font-size: .75rem; color: var(--t2); line-height: 1.3;
    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.source-picker__empty { padding: 1rem; text-align: center; color: var(--t3); font-size: .8125rem; }
.source-picker__empty--error { color: #fca5a5; }

.source-picker__footer { padding: .625rem; border-top: 1px solid var(--bd); }
.source-picker__add-btn {
    width: 100%; padding: .5rem; border-radius: .5rem;
    background: var(--acc); color: #fff; font-size: .8125rem; font-weight: 600;
    border: 1px solid var(--acc);
}
.source-picker__add-btn:disabled { opacity: .5; cursor: default; }
.source-picker__add-btn:not(:disabled):hover { filter: brightness(1.1); }

/* ── Top bar ────────────────────────────────────────────── */
.topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .5rem;
    /* +15px right padding so right-aligned items clear Office's info pane (RTL edge). */
    padding: .375rem calc(.75rem + 15px) .375rem .75rem;
    background: var(--g900);
    border-bottom: 1px solid var(--bd);
    flex: 0 0 auto;
    min-height: 2.75rem;
}
.topbar__left  { display: flex; align-items: center; gap: .25rem; min-width: 0; flex: 1 1 auto; }
.topbar__left > * { flex: 0 0 auto; } /* model selector etc. keep their size … */
.topbar__left > .breadcrumb { flex: 1 1 auto; }  /* … the breadcrumb takes the rest */
.topbar__right { display: flex; align-items: center; gap: .125rem; flex: 0 0 auto; }

/* Active-project breadcrumb — flowing text, priority truncation via flex-shrink. */
.breadcrumb {
    display: flex;
    align-items: center;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    font-size: .8125rem;
    color: var(--t3);
    line-height: 1.2;
}
.breadcrumb__sep { color: var(--t3); opacity: .6; margin: 0 .25rem; }
.breadcrumb > span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.breadcrumb__root { flex: 0 0 auto; color: var(--t2); }           /* always readable */
.breadcrumb__leaf { flex: 0 1 auto; min-width: 0; color: var(--t2); } /* kept if possible */
.breadcrumb__mid  { flex: 0 100 auto; min-width: 0; }              /* collapses before leaf */
.breadcrumb__chat { flex: 0 1000 auto; min-width: 0; }            /* lowest priority */
.breadcrumb__remove {
    flex: 0 0 auto;
    display: inline-flex; align-items: center; justify-content: center;
    width: 1rem; height: 1rem; margin-left: .25rem; padding: 0;
    border: none; border-radius: 999px; background: transparent; color: var(--t3);
    cursor: pointer; opacity: 0; transition: opacity .12s, color .12s;
}
.breadcrumb:hover .breadcrumb__remove { opacity: 1; }
.breadcrumb__remove:hover { color: #fff; }

/* user avatar circle */
.topbar__avatar {
    width: 1.875rem; height: 1.875rem;
    border-radius: 999px;
    background: var(--g800);
    border: 1px solid var(--bd2);
    display: inline-flex; align-items: center; justify-content: center;
    font-size: .6875rem; font-weight: 600; color: var(--t2);
    cursor: pointer; flex: 0 0 auto;
}

.topbar__avatar-img {
    width: 1.875rem; height: 1.875rem;
    border-radius: 999px;
    object-fit: cover;
    border: 1px solid var(--bd2);
    display: block;
    cursor: pointer; flex: 0 0 auto;
}

/* ── Model selector trigger ─────────────────────────────── */
.model-sel { position: relative; }

.model-sel__trigger {
    display: inline-flex; align-items: center; gap: .3rem;
    padding: .3rem .5rem;
    border-radius: .5rem;
    color: var(--t1);
    font-size: .9375rem; font-weight: 600;
    transition: background .12s;
    white-space: nowrap;
}
.model-sel__trigger:hover { background: rgba(255,255,255,.07); }

.model-sel__name { line-height: 1; }

.model-sel__chevron {
    color: var(--t2);
    transition: transform .15s;
    flex: 0 0 auto;
}
.model-sel__chevron--open { transform: rotate(180deg); }

/* ── Dropdown panel ─────────────────────────────────────── */
.model-sel__dropdown {
    position: absolute;
    top: calc(100% + .375rem);
    left: 0;
    z-index: 200;
    width: min(22rem, 90vw);
    background: var(--g850);
    border: 1px solid var(--bd2);
    border-radius: var(--r2xl);
    box-shadow: 0 8px 32px rgba(0,0,0,.5);
    overflow: hidden;
    display: flex; flex-direction: column;
}

/* search row */
.model-sel__search-row {
    display: flex; align-items: center; gap: .5rem;
    padding: .625rem .875rem;
    border-bottom: 1px solid var(--bd);
}
.model-sel__search-icon { flex: 0 0 auto; color: var(--t3); }
.model-sel__search {
    flex: 1; background: none; border: none; outline: none;
    font-size: .875rem; color: var(--t1);
    line-height: 1.5;
}
.model-sel__search::placeholder { color: var(--t3); }

/* category tabs */
.model-sel__tabs {
    display: flex; align-items: center; gap: 0;
    padding: .375rem .5rem;
    border-bottom: 1px solid var(--bd);
    overflow-x: auto;
    scrollbar-width: none;
}
.model-sel__tabs::-webkit-scrollbar { display: none; }

.model-sel__tab {
    flex: 0 0 auto;
    padding: .25rem .625rem;
    border-radius: .375rem;
    font-size: .8125rem; font-weight: 500;
    color: var(--t3);
    white-space: nowrap;
    transition: background .12s, color .12s;
}
.model-sel__tab:hover { color: var(--t1); }
.model-sel__tab--active {
    color: var(--t1);
    font-weight: 600;
    /* underline like OpenWebUI */
    text-decoration: underline;
    text-underline-offset: .2rem;
    text-decoration-thickness: 2px;
}

/* model list */
.model-sel__list {
    overflow-y: auto;
    max-height: 16rem;
    padding: .375rem;
    scrollbar-width: thin;
    scrollbar-color: rgba(255,255,255,.1) transparent;
}

.model-sel__item {
    display: flex; align-items: center; gap: .625rem;
    width: 100%; padding: .5rem .625rem;
    border-radius: .5rem;
    text-align: left;
    font-size: .875rem; color: var(--t1);
    transition: background .1s;
}
.model-sel__item:hover { background: rgba(255,255,255,.07); }
.model-sel__item--active { background: rgba(255,255,255,.07); }

.model-sel__item-icon {
    width: 1.375rem; height: 1.375rem;
    flex: 0 0 auto;
    display: inline-flex; align-items: center; justify-content: center;
    color: var(--t3);
}
/* Model image as a round, edge-filling icon inside the masked slot. */
.model-sel__item-img {
    width: 1.375rem; height: 1.375rem;
    border-radius: 50%;
    object-fit: cover;
    display: block;
}

.model-sel__item-name {
    flex: 1 1 auto; min-width: 0;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    font-weight: 500;
}
/* Description moved off the line into an info icon with a hover tooltip. */
.model-sel__info {
    flex: 0 0 auto;
    display: inline-flex; align-items: center;
    color: var(--t3);
    cursor: help;
}
.model-sel__info:hover { color: var(--t1); }
.model-sel__badge {
    flex: 0 0 auto; color: var(--t3);
    display: inline-flex; align-items: center;
}
.model-sel__check { flex: 0 0 auto; color: var(--t1); }

/* ── Shared icon button ─────────────────────────────────── */
.icon-btn {
    min-width: 1.875rem; height: 1.875rem;
    padding: 0 .3rem;
    border-radius: .4rem;
    display: inline-flex; align-items: center; justify-content: center;
    gap: .3rem;
    color: var(--t2);
    transition: background .12s, color .12s;
    white-space: nowrap; font-size: .75rem;
}
.icon-btn:hover { background: rgba(255,255,255,.08); color: var(--t1); }
.icon-btn svg { flex: 0 0 auto; }

/* ── Conversation wrap (positions scroll btn) ───────────── */
.conversation-wrap {
    flex: 1 1 auto;
    min-height: 0;
    position: relative;
    display: flex;
    flex-direction: column;
}

/* ── Conversation scroll area ───────────────────────────── */
.conversation {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 1.25rem 2rem .75rem;
    scrollbar-width: thin;
    scrollbar-color: rgba(255,255,255,.1) transparent;
}
.conversation::-webkit-scrollbar       { width: .3rem; }
.conversation::-webkit-scrollbar-track { background: transparent; }
.conversation::-webkit-scrollbar-thumb { background: rgba(255,255,255,.1); border-radius: 999px; }

/* ── Scroll-to-bottom button ────────────────────────────── */
.scroll-btn {
    position: absolute;
    bottom: .625rem;
    left: 50%;
    transform: translateX(-50%);
    width: 2rem; height: 2rem;
    border-radius: 999px;
    background: var(--g800);
    border: 1px solid var(--bd2);
    color: var(--t2);
    display: inline-flex; align-items: center; justify-content: center;
    box-shadow: 0 2px 8px rgba(0,0,0,.4);
    animation: bounce-down .9s ease-in-out infinite;
    z-index: 10;
    transition: background .12s, color .12s;
}
.scroll-btn:hover { background: var(--g850); color: var(--t1); }
@keyframes bounce-down {
    0%,100% { transform: translateX(-50%) translateY(0);    }
    50%     { transform: translateX(-50%) translateY(4px);  }
}

/* ── Message list ───────────────────────────────────────── */
.message-list {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;   /* clear visual separation between turns */
    width: 100%;
}

/* ── User message (right-aligned bubble) ────────────────── */
.message--user {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: .375rem;
}

/* file chips row above user bubble */
.msg-files {
    display: flex;
    flex-wrap: wrap;
    gap: .375rem;
    justify-content: flex-end;
}

.msg-file-chip {
    display: inline-flex;
    align-items: center;
    gap: .375rem;
    padding: .3rem .75rem;
    border-radius: .625rem;
    background: var(--g850);
    border: 1px solid var(--bd2);
    max-width: 13rem;
    cursor: default;
}
.msg-file-chip__icon { flex: 0 0 auto; color: var(--t3); }
.msg-file-chip__name {
    font-size: .75rem; font-weight: 500; color: var(--t1);
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    max-width: 5rem;
}
.msg-file-chip__size { font-size: .6875rem; color: var(--t3); white-space: nowrap; }
.message--user .msg-bubble {
    /* bg-gray-850, rounded-3xl, px-5 py-2 — straight from OpenWebUI */
    background: var(--g850);
    border-radius: var(--r3xl) var(--r3xl) .375rem var(--r3xl);
    padding: .5rem 1.25rem;     /* py-2 px-5 */
    max-width: 85%;
    color: var(--t1);
    font-size: .9375rem;        /* slightly tighter than base */
    line-height: 1.6;
    word-break: break-word;
    white-space: pre-wrap;
}

/* ── Assistant message (left, no bubble) ────────────────── */
.message--assistant {
    display: flex;
    flex-direction: column;
    gap: .375rem;
    align-items: flex-start;
    width: 100%;
}

.msg-header {
    display: flex;
    align-items: center;
    gap: .5rem;
}

/* The two-tone icon from the screenshot */
.msg-avatar {
    width: 1.625rem; height: 1.625rem;
    border-radius: 50%;
    flex: 0 0 auto;
    overflow: hidden;
    display: inline-flex; align-items: center; justify-content: center;
    background: none;
}
.msg-avatar img { width: 100%; height: 100%; object-fit: cover; }

.msg-name {
    font-size: .9375rem;
    font-weight: 600;
    color: var(--t1);
    line-height: 1;
}

/* Timestamps — hidden by default, visible on parent hover */
.msg-timestamp {
    font-size: .6875rem;
    color: var(--t3);
    white-space: nowrap;
    opacity: 0;
    transition: opacity .15s;
}

/* assistant timestamp sits in the header row after the name */
.msg-timestamp--assistant { margin-left: .25rem; }

/* user timestamp sits above the bubble, right-aligned */
.msg-timestamp--user {
    display: block;
    text-align: right;
    margin-bottom: .125rem;
}

/* reveal on hover of the message container */
.message--assistant:hover .msg-timestamp--assistant,
.message--user:hover .msg-timestamp--user { opacity: 1; }

/* Assistant body text — matches prose style from screenshot */
.msg-body {
    padding: 0;
    color: oklch(0.872 0.01 258.338);   /* normal paragraph text (assistant) */
    font-size: .9375rem;
    line-height: 1.65;          /* slightly tighter than leading-relaxed for narrow pane */
    word-break: break-word;
    white-space: normal;        /* markdown is rendered as structured HTML now */
    width: 100%;
}

/* paragraphs within body get spacing */
.msg-body p { margin: 0 0 .75em; }
.msg-body p:last-child { margin-bottom: 0; }

/* bullet lists */
.msg-body ul {
    margin: .25em 0 .75em;
    padding-left: 1.25rem;
    list-style: disc;
}
.msg-body ol {
    margin: .25em 0 .75em;
    padding-left: 1.4rem;
    list-style: decimal;
}
.msg-body li { margin-bottom: .25em; }
.msg-body li > ul, .msg-body li > ol { margin: .25em 0 .25em 1rem; }

/* headings */
.msg-body h1, .msg-body h2, .msg-body h3,
.msg-body h4, .msg-body h5, .msg-body h6 {
    margin: 1em 0 .4em;
    line-height: 1.3;
    font-weight: 600;
}
.msg-body h1:first-child, .msg-body h2:first-child, .msg-body h3:first-child { margin-top: 0; }
.msg-body h1 { font-size: 1.3em; }
.msg-body h2 { font-size: 1.18em; }
.msg-body h3 { font-size: 1.06em; }
.msg-body h4, .msg-body h5, .msg-body h6 { font-size: 1em; }

/* links */
.msg-body a { color: #fff; text-decoration: underline; }

/* everything that isn't plain paragraph text renders pure white
   (emphasis, headings, links, code, tables) */
.msg-body strong,
.msg-body b,
.msg-body em,
.msg-body i,
.msg-body del,
.msg-body a,
.msg-body h1, .msg-body h2, .msg-body h3,
.msg-body h4, .msg-body h5, .msg-body h6,
.msg-body code,
.msg-body th,
.msg-body td { color: #fff; }

/* emphasis */
.msg-body strong { font-weight: 600; }
.msg-body em { font-style: italic; }
.msg-body del { opacity: .7; }

/* inline + block code */
.msg-body code {
    font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
    font-size: .85em;
    background: rgba(127, 127, 127, .14);
    padding: .12em .35em;
    border-radius: 4px;
}
.msg-body pre {
    margin: .5em 0 .8em;
    padding: .7em .85em;
    background: rgba(127, 127, 127, .12);
    border-radius: 8px;
    overflow-x: auto;
    white-space: pre;
}
.msg-body pre code {
    background: none;
    padding: 0;
    font-size: .85em;
    white-space: pre;
}
/* CodeMirror-Codeblock (read-only, One-Dark) */
.cm-block {
    margin: .5em 0 .8em;
    border: 1px solid var(--bd);
    border-radius: var(--r3xl);
    overflow: hidden;
    background: #000000;
}
.cm-block__bar {
    display: flex;
    align-items: center;
    gap: .5rem;
    padding: .5rem .85rem;
    background: #000000;
    border-bottom: 1px solid var(--bd);
}
.cm-block__lang {
    font-size: .75rem;
    color: var(--t1);
    font-weight: 500;
}
.cm-block__actions { margin-left: auto; display: flex; align-items: center; gap: .25rem; }
.cm-block__action {
    display: inline-flex;
    align-items: center;
    gap: .3rem;
    color: var(--t2);
    font-size: .75rem;
    padding: .2rem .45rem;
    border-radius: 6px;
}
.cm-block__action:hover { color: var(--t1); background: rgba(255, 255, 255, .08); }
.cm-block__action svg { flex: 0 0 auto; }
.cm-block__copy svg { width: 14px; height: 14px; }
.cm-block__copy--copied { color: #86efac; }
/* Chevron: zeigt nach unten (aufgeklappt = einklappbar); nach oben, wenn eingeklappt. */
.cm-block__toggle svg { transition: transform .15s ease; }
.cm-block--collapsed .cm-block__toggle svg { transform: rotate(180deg); }
/* Collapse-Zustand: Editor aus, „N ausgeblendete Zeilen" an. */
.cm-block__collapsed {
    display: none;
    padding: .5rem .85rem .7rem;
    font-size: .8125rem;
    font-style: italic;
    color: var(--t3);
}
.cm-block--collapsed .cm-block__editor { display: none; }
.cm-block--collapsed .cm-block__collapsed { display: block; }
/* Editor erstreckt sich immer voll — keine eigene Scrollbar (Höhe = Inhalt, Zeilen umbrechen). */
.cm-block .cm-editor { font-size: .8125rem; height: auto; }
.cm-block .cm-scroller {
    font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
    overflow: visible;
}
.cm-block .cm-editor.cm-focused { outline: none; }
/* One-Dark setzt den Editor-Hintergrund auf #282c34 — auf reines Schwarz überschreiben. */
.cm-block .cm-editor,
.cm-block .cm-scroller,
.cm-block .cm-gutters { background-color: #000000; }
/* etwas Luft am unteren Rand, damit die letzte Zeile nicht an der Rundung klebt */
.cm-block .cm-content { padding-bottom: .6rem; }
.cm-block .cm-gutters { padding-bottom: .6rem; }

/* Inline-Code: klickbar → Inhalt in die Zwischenablage */
.msg-body code.md-inline-code {
    cursor: pointer;
    transition: background-color .12s ease;
}
.msg-body code.md-inline-code:hover { background: rgba(127, 127, 127, .26); }
.msg-body code.md-inline-code--copied {
    background: rgba(34, 197, 94, .22);
    color: #86efac;
}

/* blockquote */
.msg-body blockquote {
    margin: .5em 0;
    padding: .2em .9em;
    border-left: 3px solid rgba(127, 127, 127, .35);
    color: var(--t2, inherit);
}

/* horizontal rule */
.msg-body hr {
    border: none;
    border-top: 1px solid rgba(127, 127, 127, .3);
    margin: 1em 0;
}

/* tables (GFM) — Prose-UI-Stil: kein Außenrahmen, kein Header-Hintergrund,
   nur horizontale Trennlinien */
.msg-body table {
    border-collapse: collapse;
    width: 100%;
    margin: .85em 0;
    font-size: .875em;
    line-height: 1.5;
}
.msg-body th, .msg-body td {
    padding: .5em .8em;
    text-align: left;
    vertical-align: top;
    border-bottom: 1px solid var(--bd);   /* horizontal dividers only */
}
.msg-body thead th {
    color: #fff;
    font-weight: 600;
    border-bottom: 1px solid var(--bd2);
}
.msg-body tbody tr:last-child td { border-bottom: none; }
.msg-body tbody tr:hover { background: rgba(255, 255, 255, .03); }

/* first column kept on one line when all its cells are short (< 10 chars) */
.msg-body table.md-table--nowrap-1 th:first-child,
.msg-body table.md-table--nowrap-1 td:first-child { white-space: nowrap; }

/* hover copy-button on tables (rich-text copy).
   The rail spans the full table height; the button is position:sticky inside it,
   so it follows the scroll and stays pinned to the top of the visible area until
   the table itself is (nearly) scrolled out. */
.md-table-wrap { position: relative; }
.md-table-rail {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 2px;
    width: 26px;
    pointer-events: none;   /* don't block the table; the button re-enables itself */
}
.md-table-copy {
    position: sticky;
    top: 2px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: var(--g900);
    color: var(--t2);
    cursor: pointer;
    pointer-events: auto;
    opacity: 0;
    transition: opacity .12s, background .12s, color .12s;
}
.md-table-wrap:hover .md-table-copy,
.md-table-copy:focus-visible { opacity: 1; }
.md-table-copy:hover { background: var(--g850); color: var(--t1); }
.md-table-copy--copied { color: #4ade80; opacity: 1; }

/* GFM task lists */
.msg-body li input[type="checkbox"] { margin-right: .4em; }
.msg-body ul:has(> li > input[type="checkbox"]) { list-style: none; padding-left: .25rem; }

/* inline images */
.msg-body img { max-width: 100%; border-radius: 6px; }

/* inline citation button (replaces [n] when sources are present) */
.md-citation {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    width: fit-content;
    vertical-align: text-bottom;
    -webkit-user-select: none;   /* excluded from text selection / copy (like OWUI) */
    user-select: none;
    transform: translateY(2px);
    margin: 0 1px;
    padding: 1px 8px 1px 6px;
    font-size: 10px;
    line-height: 1.4;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    background: rgba(255, 255, 255, .06);
    color: rgba(255, 255, 255, .8);
    transition: color .12s, background .12s;
}
.md-citation:hover { color: #fff; background: rgba(255, 255, 255, .10); }
.md-citation__label {
    white-space: nowrap;   /* label is already truncated to ≤20 chars in JS */
}
.md-citation__icon {
    flex: 0 0 auto;
    width: 12px;
    height: 12px;
    border-radius: 3px;
}
.md-citation__icon--doc {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    opacity: .75;
}

/* ── Thinking / Reasoning block ─────────────────────────── */
.thinking-block {
    margin: .25rem 0 .375rem;
    border-radius: .625rem;
    border: 1px solid rgba(99, 102, 241, 0.25);
    background: rgba(99, 102, 241, 0.06);
    overflow: hidden;
    width: 100%;
}

.thinking-block__toggle {
    display: flex;
    align-items: center;
    gap: .4rem;
    width: 100%;
    padding: .4rem .625rem;
    text-align: left;
    font-size: .8125rem;
    color: #a5b4fc;  /* indigo-300 */
    transition: background .12s;
}
.thinking-block__toggle:hover { background: rgba(99, 102, 241, 0.1); }

.thinking-block__spinner svg {
    animation: thinking-spin 1.2s linear infinite;
    flex: 0 0 auto;
}
@keyframes thinking-spin { to { transform: rotate(360deg); } }

.thinking-block__label { flex: 1; font-weight: 500; }

.thinking-block__chevron {
    flex: 0 0 auto;
    transition: transform .15s;
    color: #818cf8;
}
.thinking-block__chevron--open { transform: rotate(180deg); }

.thinking-block__content {
    padding: .375rem .625rem .5rem;
    border-top: 1px solid rgba(99, 102, 241, 0.15);
    display: flex;
    flex-direction: column;
    gap: .25rem;
}

/* ── Thinking step items ── */
.ts-item {
    display: flex;
    align-items: flex-start;
    gap: .5rem;
    padding: .2rem .25rem;
    border-radius: .375rem;
    cursor: default;
    position: relative;
}
.ts-item:hover { background: rgba(255,255,255,.04); }

.ts-item__dot {
    flex: 0 0 6px;
    width: 6px; height: 6px;
    border-radius: 50%;
    margin-top: .375rem;
    background: rgba(99,102,241,.5);
}
.ts-item--tool    .ts-item__dot { background: #a5b4fc; }
.ts-item--result  .ts-item__dot { background: rgba(99,102,241,.25); }
.ts-item--muted   .ts-item__dot { background: var(--t3); }
.ts-item--reasoning .ts-item__dot { background: rgba(129,140,248,.6); }

.ts-item__text {
    flex: 1 1 auto;
    font-size: .7813rem;
    line-height: 1.5;
    color: var(--t2);
    /* max 2 lines, truncated */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
}
.ts-item--tool   .ts-item__text { color: #a5b4fc; font-family: ui-monospace, monospace; font-size: .75rem; }
.ts-item--result .ts-item__text { color: var(--t3); font-size: .75rem; }
.ts-item--muted  .ts-item__text { color: var(--t3); font-style: italic; }

/* ── Tooltip on hover ── */
.ts-tooltip {
    position: fixed;
    z-index: 9999;
    max-width: min(22rem, 90vw);
    padding: .625rem .875rem;
    border-radius: .625rem;
    background: var(--g800);
    border: 1px solid var(--bd2);
    box-shadow: 0 8px 24px rgba(0,0,0,.5);
    font-size: .8125rem;
    color: var(--t1);
    line-height: 1.55;
    white-space: pre-wrap;
    pointer-events: none;
}

/* ── Action row under assistant message ─────────────────── */
.msg-actions {
    display: flex;
    align-items: center;
    gap: .125rem;
    margin-top: .125rem;
    flex-wrap: wrap;
}

/* hide action bar on non-last messages, reveal on hover */
.message--assistant--hoverable .msg-actions {
    opacity: 0;
    transition: opacity .15s;
}
.message--assistant--hoverable:hover .msg-actions {
    opacity: 1;
}
.msg-action-btn {
    width: 1.75rem; height: 1.75rem;
    border-radius: .375rem;
    display: inline-flex; align-items: center; justify-content: center;
    color: var(--t3);
    transition: color .12s, background .12s;
}
.msg-action-btn:hover { color: #fff; background: rgba(255,255,255,.06); }

/* ── Web search sources block ───────────────────────────── */
.sources-block {
    margin: .375rem 0 .25rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: .375rem;
}
/* Top row: toggle pill + visibility action — never wraps; the action truncates instead. */
.sources-block__bar {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: .375rem;
    min-width: 0;
}
.sources-block__bar .sources-block__toggle { flex: 0 0 auto; }
/* Hover-revealed show/hide-citations action — grows the block when revealed; shrinks
   (front-truncated) rather than wrapping below the pill when space is tight. */
.sources-block__visibility {
    flex: 0 1 auto;
    min-width: 0;
    height: 2rem;
    border-radius: 999px;
    border: 1px solid var(--bd);
    background: transparent;
    font-size: .75rem;
    font-weight: 500;
    color: var(--t2);
    cursor: pointer;
    /* hidden until the block is hovered */
    max-width: 0;
    padding: 0;
    border-width: 0;
    opacity: 0;
    overflow: hidden;
    transition: max-width .16s ease, opacity .12s ease, padding .16s ease, background .12s, color .12s;
}
.sources-block:hover .sources-block__visibility,
.sources-block__visibility:focus-visible {
    max-width: 14rem;
    padding: 0 .875rem;
    border-width: 1px;
    opacity: 1;
}
.sources-block__visibility:hover { background: rgba(255,255,255,.06); color: var(--t1); }
/* Front truncation: clip the start so the verb ("…anzeigen"/"…verstecken") stays
   visible. RTL block = left-side ellipsis; the text is isolated as a single LTR run
   (<bdi>) so the word order is preserved (no reordering). */
.sources-block__visibility-label {
    display: block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    direction: rtl;
}
.sources-block__visibility-text {
    unicode-bidi: isolate;
    direction: ltr;
}
/* red "!" after the word "Quellen" when citations are hidden */
.sources-block__alert {
    margin-left: .3rem;
    color: #f87171;
    font-weight: 700;
}
/* hidden inline citations in the message body */
.msg-body--citations-hidden .md-citation { display: none; }

/* pill button: stacked favicons + "+N" + count */
.sources-block__toggle {
    display: inline-flex;
    align-items: center;
    gap: .375rem;
    height: 2rem;
    padding: 0 .875rem;
    border-radius: 999px;
    border: 1px solid var(--bd);
    background: transparent;
    font-size: .75rem;
    font-weight: 500;
    color: var(--t2);
    transition: background .12s, color .12s;
}
.sources-block__toggle:hover { background: rgba(255,255,255,.06); color: var(--t1); }

.sources-block__favicons {
    display: inline-flex;
    align-items: center;
}
.sources-block__favicons > * + * { margin-left: -4px; }
.sources-block__favicon {
    width: 16px;
    height: 16px;
    border-radius: 999px;
    flex: 0 0 auto;
    border: 1px solid var(--g900);
    background: transparent;
}
.sources-block__more {
    width: 16px;
    height: 16px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    font-weight: 600;
    letter-spacing: -.03em;
    color: var(--t2);
    background: var(--g800);
    border: 1px solid var(--g900);
}

.sources-block__list {
    flex-basis: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: .375rem;
    padding: .375rem 0;
}
.sources-block__item {
    display: flex;
    align-items: center;
    gap: .375rem;
    text-decoration: none;
    min-width: 0;
    color: var(--t2);
}
.sources-block__index {
    flex: 0 0 auto;
    box-sizing: border-box;
    min-width: 1.35rem;
    text-align: center;
    font-weight: 500;
    font-size: .6875rem;
    color: var(--t2);
    background: var(--g850);
    border-radius: .375rem;
    padding: 0 .35rem;
    line-height: 1.4;
}
.sources-block__url {
    flex: 1 1 auto;
    font-size: .75rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    transition: color .12s;
}
.sources-block__item:hover .sources-block__url { color: #fff; }
/* Knowledge-file sources use a file icon instead of a favicon (collapsed strip). */
.sources-block__favicon--icon {
    border: none;
    border-radius: 0;
    background: transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--t2);
}
.sources-block__favicon--icon svg { display: block; }
/* Leading icon in each expanded list item (favicon for web, file icon for knowledge).
   Fixed 16×16 box so the icon + text columns line up across rows. */
.sources-block__item-icon {
    flex: 0 0 auto;
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--t3);
}
.sources-block__item-icon svg { display: block; }
.sources-block__item-favicon {
    box-sizing: border-box;
    border-radius: 999px;
    border: 1px solid var(--g900);
    background: transparent;
}
.sources-block__item--file { cursor: default; }

/* active web-search chip in the composer toolbar (sky accent, ✕ on hover) */
.web-search-chip {
    display: inline-flex;
    align-items: center;
    gap: .375rem;
    padding: 7px;
    border-radius: 999px;
    cursor: pointer;
    transition: background-color .3s, color .3s;
    color: #7dd3fc;                          /* sky-300 */
    background: rgba(56, 163, 248, .10);     /* sky-400/10 */
    border: 1px solid rgba(14, 165, 233, .20); /* sky-500/20 */
}
.web-search-chip:hover { background: rgba(2, 132, 199, .14); } /* sky-600/~ */
.web-search-chip__globe { flex: 0 0 auto; }
.web-search-chip__x {
    display: none;
    align-items: center;
    flex: 0 0 auto;
}
.web-search-chip:hover .web-search-chip__x { display: inline-flex; }

/* fork / branch switcher (‹ 1/2 ›) under a forked message */
.branch-switcher {
    display: inline-flex;
    align-items: center;
    gap: .125rem;
    align-self: flex-start;
    margin-top: .25rem;
    color: var(--t2);
}
/* under a user message: right-aligned */
.message--user .branch-switcher { align-self: flex-end; margin-left: auto; }

/* footer row under a user message: switcher + hover edit action, right-aligned */
.msg-user-footer {
    display: flex;
    align-items: center;
    gap: .25rem;
    align-self: flex-end;
    margin-top: .125rem;
}
.msg-user-footer .branch-switcher { margin-top: 0; margin-left: 0; }
.msg-user-actions {
    display: inline-flex;
    align-items: center;
    opacity: 0;
    transition: opacity .12s;
}
.message--user:hover .msg-user-actions,
.msg-user-actions:focus-within { opacity: 1; }

/* inline edit composer (replaces a user message while editing) */
.edit-composer {
    width: 100%;
    background: var(--g850);
    border: 1px solid var(--bd);
    border-radius: var(--r2xl, 1rem);
    padding: .75rem .875rem;
    display: flex;
    flex-direction: column;
    gap: .75rem;
}
.edit-composer__textarea {
    width: 100%;
    resize: none;
    border: none;
    outline: none;
    background: transparent;
    color: var(--t1);
    font: inherit;
    font-size: .9375rem;
    line-height: 1.5;
}
.edit-composer__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .5rem;
}
.edit-composer__right { display: flex; gap: .5rem; }
.edit-composer__btn {
    height: 2rem;
    padding: 0 1rem;
    border-radius: 999px;
    font-size: .8125rem;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background .12s, color .12s, filter .12s;
}
.edit-composer__btn--ghost { background: transparent; border-color: var(--bd2); color: var(--t1); }
.edit-composer__btn--ghost:hover { background: rgba(255, 255, 255, .06); }
.edit-composer__btn--dark { background: var(--g950); color: #fff; }
.edit-composer__btn--dark:hover { background: #000; }
.edit-composer__btn--primary { background: #fff; color: #111; }
.edit-composer__btn--primary:hover { filter: brightness(.92); }
.branch-switcher__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.75rem;
    height: 1.75rem;
    padding: 0;
    border: none;
    background: transparent;
    color: inherit;
    border-radius: .375rem;
    cursor: pointer;
    transition: background .12s, color .12s;
}
.branch-switcher__btn:hover:not(:disabled) { background: rgba(255, 255, 255, .08); color: #fff; }
.branch-switcher__btn:disabled { opacity: .35; cursor: default; }
.branch-switcher__count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 1.75rem;
    font-size: .75rem;
    letter-spacing: .08em;
    font-weight: 600;
    color: var(--t1);
    min-width: fit-content;
    padding: 0 .125rem;
}

/* ── Modal dialog (reusable) ────────────────────────────── */
.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.25rem;
    background: rgba(0, 0, 0, .72);   /* strong dim */
    backdrop-filter: blur(2px);
}
.modal {
    width: 100%;
    max-width: 28rem;
    background: var(--g900);
    border: 1px solid var(--bd2);
    border-radius: var(--r2xl, 1rem);
    padding: 1.25rem;
    box-shadow: 0 20px 50px rgba(0, 0, 0, .5);
}
.modal__body {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
}
.modal__icon {
    flex: 0 0 auto;
    width: 64px;
    height: 64px;
    margin-top: .5rem;   /* half the .modal__body gap */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--t2);
}
.modal__icon svg { width: 64px; height: 64px; }
.modal__title {
    margin: .1rem 0 .4rem;
    font-size: 1.0625rem;
    font-weight: 600;
    color: var(--t1);
}
.modal__message {
    margin: 0;
    font-size: .9375rem;
    line-height: 1.5;
    color: var(--t2);
}
.modal__actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: .5rem;
    margin-top: 1.25rem;
}
.modal__btn {
    height: 2.25rem;
    padding: 0 1.1rem;
    border-radius: 999px;
    font-size: .875rem;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background .12s, color .12s, filter .12s;
}
.modal__btn--left { margin-right: auto; }
.modal__btn--grey { background: var(--g800); color: var(--t1); }
.modal__btn--grey:hover { background: var(--g850); }
.modal__btn--danger { background: #dc2626; color: #fff; }
.modal__btn--danger:hover { filter: brightness(1.08); }
.modal__btn--primary { background: #fff; color: #111; }
.modal__btn--primary:hover { filter: brightness(.92); }

/* ── Follow-up questions block ──────────────────────────── */
.followups {
    margin-top: .75rem;
    display: flex;
    flex-direction: column;
    gap: .25rem;
}
.followups__label {
    font-size: .75rem;
    font-weight: 600;
    color: var(--t2);
    margin-bottom: .25rem;
    letter-spacing: .03em;
}
.followup-btn {
    display: block;
    text-align: left;
    font-size: .875rem;       /* text-sm */
    color: var(--sky);        /* text-sky-500 */
    line-height: 1.5;
    padding: .125rem 0;
    background: none;
    border: none;
    cursor: pointer;
    transition: opacity .12s;
}
.followup-btn:hover { opacity: .75; }

/* ── Typing indicator ───────────────────────────────────── */
.typing-dots { display: inline-flex; align-items: center; gap: .3rem; padding: .2rem 0; }
.typing-dot {
    width: 5px; height: 5px;
    border-radius: 50%;
    background: var(--t3);
    animation: dot-pulse 1.4s infinite ease-in-out;
}
.typing-dot:nth-child(2) { animation-delay: .2s; }
.typing-dot:nth-child(3) { animation-delay: .4s; }
@keyframes dot-pulse {
    0%,60%,100% { opacity: .3; transform: scale(.8); }
    30%         { opacity: 1;  transform: scale(1);  }
}

/* ── Quick actions — flex, centered, top-aligned ────────── */
.quick-actions {
    flex: 1 1 auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 1.5rem 1rem .5rem;
    overflow-y: auto;
}
.quick-actions__grid {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;
    justify-content: center;
    align-content: flex-start;
    max-width: 26rem;
    width: 100%;
}
.quick-actions__btn {
    display: flex; flex-direction: column; align-items: flex-start;
    gap: .2rem; padding: .625rem .875rem;
    border-radius: var(--r2xl);
    border: 1px solid var(--bd2);
    background: var(--g850);
    text-align: left;
    transition: background .12s, border-color .12s;
    min-width: 8rem; max-width: 14rem; flex: 1 1 8rem;
}
.quick-actions__btn:hover { background: var(--g800); border-color: rgba(255,255,255,.2); }
.quick-actions__title { font-size: .8125rem; font-weight: 500; color: var(--t1); line-height: 1.3; }
.quick-actions__sub {
    font-size: .6875rem; color: var(--t3); line-height: 1.4;
    display: -webkit-box; -webkit-line-clamp: 2;
    -webkit-box-orient: vertical; overflow: hidden;
}

/* ── Composer ───────────────────────────────────────────── */
.composer { flex: 0 0 auto; padding: .5rem 1rem .875rem; }

/* Hero state: model info centered above input */
.composer--hero {
    display: flex; flex-direction: column;
    align-items: center; gap: 1rem;
    padding: .75rem 1rem 1.25rem;
}
.composer__hero {
    display: flex; flex-direction: column;
    align-items: center; gap: .3rem;
    text-align: center;
}
.composer__model-icon {
    width: 5.25rem; height: 5.25rem;
    border-radius: 1.25rem; overflow: hidden;
    display: inline-flex; align-items: center; justify-content: center;
    background: none;
    margin-bottom: .3rem; flex: 0 0 auto;
}
.composer__model-icon img { width: 100%; height: 100%; object-fit: contain; }
.composer__model-name {
    margin: 0; font-size: 1.25rem; font-weight: 600;
    color: var(--t1); line-height: 1.15;
}
.composer__model-desc {
    margin: 0; font-size: .8125rem; color: var(--t2);
    line-height: 1.5; max-width: 22rem;
}

/* Input box (shared between hero and chat state) */
.composer__box {
    width: 100%;
    background: var(--g850);
    border: 1px solid var(--bd);
    border-radius: var(--r3xl);    /* 1.5rem — matches OpenWebUI */
    padding: .75rem 1rem .625rem;
    display: flex; flex-direction: column; gap: .5rem;
    transition: border-color .15s;
}
.composer__box--active,
.composer__box:focus-within { border-color: var(--bd2); }

.composer__textarea {
    width: 100%;
    min-height: 1.5rem; max-height: 33vh;
    resize: none; border: none; outline: none;
    background: transparent;
    color: var(--t1);
    font-size: .9375rem;
    line-height: 1.6;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(255,255,255,.08) transparent;
}
.composer__textarea::placeholder { color: var(--t3); }

.composer__toolbar {
    display: flex; align-items: center;
    justify-content: space-between; gap: .375rem;
}
.composer__toolbar-left { display: flex; align-items: center; gap: .125rem; }
.composer__toolbar-right { display: flex; align-items: center; gap: .5rem; }

/* separator line between left groups */
.composer__sep {
    width: 1px; height: 1rem;
    background: var(--bd2);
    margin: 0 .25rem;
    flex: 0 0 auto;
}

.composer__tools-count {
    font-size: .6875rem; font-weight: 600;
    background: rgba(255,255,255,.1);
    padding: .1rem .35rem; border-radius: .3rem; line-height: 1.3;
}

/* mic button — same size as send, filled icon */
.composer__mic {
    width: 1.875rem; height: 1.875rem;
    border-radius: 999px;
    display: inline-flex; align-items: center; justify-content: center;
    background: rgba(255,255,255,.08);
    color: var(--t2);
    transition: background .15s, color .15s; flex: 0 0 auto;
}
.composer__mic:hover { background: rgba(255,255,255,.14); color: var(--t1); }

.composer__send {
    width: 1.875rem; height: 1.875rem;
    border-radius: 999px;
    display: inline-flex; align-items: center; justify-content: center;
    background: var(--t1); color: var(--g950);
    transition: opacity .15s, background .15s; flex: 0 0 auto;
}
.composer__send:disabled { opacity: .2; cursor: not-allowed; }
.composer__send:not(:disabled):hover { background: #e5e5e5; }

.composer__stop {
    width: 1.875rem; height: 1.875rem;
    border-radius: 999px;
    display: inline-flex; align-items: center; justify-content: center;
    background: rgba(239, 68, 68, 0.15);
    color: #f87171;
    border: 1px solid rgba(239, 68, 68, 0.3);
    transition: background .15s; flex: 0 0 auto;
}
.composer__stop:hover { background: rgba(239, 68, 68, 0.28); }

/* Aborted message badge */
.msg-aborted {
    display: inline-flex;
    align-items: center;
    gap: .375rem;
    padding: .3rem .75rem;
    border-radius: .5rem;
    background: rgba(239, 68, 68, 0.08);
    border: 1px solid rgba(239, 68, 68, 0.2);
    color: #f87171;
    font-size: .8125rem;
    margin-top: .125rem;
}

/* ── File chips strip ───────────────────────────────────── */
.composer__files {
    display: flex;
    flex-wrap: wrap;
    gap: .375rem;
    padding-bottom: .25rem;
}
.file-chip {
    position: relative;
    display: inline-flex; align-items: center; gap: .375rem;
    padding: .3rem .625rem;
    border-radius: .625rem;
    background: var(--g800);
    border: 1px solid var(--bd2);
    max-width: 10rem;
    cursor: default;
}
.file-chip__icon { flex: 0 0 auto; color: var(--t3); }
.file-chip__name {
    font-size: .75rem; font-weight: 500; color: var(--t1);
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    max-width: 4rem;
}
.file-chip__size { font-size: .6875rem; color: var(--t3); white-space: nowrap; }
.file-chip__remove {
    position: absolute;
    top: -.4rem; right: -.4rem;
    width: 1rem; height: 1rem;
    border-radius: 999px;
    background: #f5f5f5;
    border: none;
    color: var(--g900);
    display: none;
    align-items: center; justify-content: center;
    line-height: 1;
}
.file-chip:hover .file-chip__remove { display: inline-flex; }
.file-chip__remove:hover { background: #ffffff; }

/* Multiple attachments stack vertically (untereinander), right-aligned. */
.message--user .msg-files--attachments {
    flex-direction: column;
    align-items: flex-end;
}

/* Attachment chips pinned to a user message mirror the user bubble (bg + colors + padding).
   All chips share a fixed 240px width; the name truncates, full name in the tooltip. */
.message--user .file-chip {
    box-sizing: border-box;
    flex: 0 0 auto;           /* don't shrink to content in the column stack */
    width: 240px;
    max-width: 240px;         /* override the base .file-chip max-width: 10rem */
    background: var(--g850);
    border: none;
    border-radius: var(--r3xl);
    padding: .5rem 1.25rem;   /* match the bubble's py-2 px-5 */
}
.message--user .file-chip__name {
    flex: 1 1 auto;
    min-width: 0;
    max-width: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.message--user .file-chip__size { flex: 0 0 auto; }
.message--user .file-chip__icon {
    color: #fff;
    display: inline-flex;
    align-items: center;
    line-height: 1;
}
.message--user .file-chip__icon svg { display: block; }

/* Pointed corners build a connected stack toward the bubble:
   first attachment → bottom-right; all further → top-right + bottom-right. */
.message--user .file-chip:first-child {
    border-radius: var(--r3xl) var(--r3xl) .375rem var(--r3xl);
}
.message--user .file-chip:not(:first-child) {
    border-radius: var(--r3xl) .375rem .375rem var(--r3xl);
}

/* When attachments sit above the bubble, the pointed corner moves to the
   top-right (toward the attachments) instead of the bottom-right. */
.message--user .msg-bubble--attached {
    border-radius: var(--r3xl) .375rem var(--r3xl) var(--r3xl);
}

/* ── Attach / Tools dropdown ────────────────────────────── */
.c-popover { position: relative; }

.c-dropdown {
    position: absolute;
    bottom: calc(100% + .375rem);
    left: 0;
    z-index: 200;
    min-width: 13rem;
    background: var(--g850);
    border: 1px solid var(--bd2);
    border-radius: var(--r2xl);
    box-shadow: 0 8px 24px rgba(0,0,0,.5);
    overflow: hidden;
    padding: .375rem;
    display: flex; flex-direction: column; gap: .125rem;
}

.c-dropdown__header {
    display: flex; align-items: center; gap: .5rem;
    padding: .5rem .625rem;
    border-radius: .5rem;
    font-size: .875rem; font-weight: 600; color: var(--t1);
    border-bottom: 1px solid var(--bd);
    margin-bottom: .125rem;
}
.c-dropdown__header-label { display: flex; align-items: center; gap: .375rem; flex: 1; }
.c-dropdown__header-count {
    font-size: .75rem; font-weight: 600;
    color: var(--t3);
    background: rgba(255,255,255,.08);
    padding: .1rem .35rem; border-radius: .3rem;
}

.c-dropdown__item {
    display: flex; align-items: center; gap: .625rem;
    width: 100%; padding: .5rem .625rem;
    border-radius: .5rem;
    text-align: left; font-size: .875rem; color: var(--t1);
    transition: background .1s;
}
.c-dropdown__item:hover { background: rgba(255,255,255,.07); }
.c-dropdown__item--tool { justify-content: space-between; }
.c-dropdown__tool-icon { flex: 0 0 auto; color: var(--t3); }
.c-dropdown__item-label { flex: 1; }
.c-dropdown__item-arrow { flex: 0 0 auto; color: var(--t3); }

/* toggle switch */
.c-toggle {
    width: 2.125rem; height: 1.125rem;
    border-radius: 999px;
    background: var(--bd2);
    position: relative;
    flex: 0 0 auto;
    transition: background .2s;
}
.c-toggle--on { background: var(--t1); }
.c-toggle__knob {
    position: absolute;
    top: .15rem; left: .15rem;
    width: .825rem; height: .825rem;
    border-radius: 999px;
    background: var(--g900);
    transition: transform .2s;
}
.c-toggle--on .c-toggle__knob { transform: translateX(1rem); }

/* ── Voice recorder — single row ────────────────────────── */
.voice-recorder {
    width: 100%;
    background: var(--g850);
    border: 1px solid var(--bd2);
    border-radius: var(--r3xl);
    padding: .5rem .75rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: .625rem;
    height: 2.75rem;     /* same height as the composer box toolbar row */
}

/* Visualizer — fills all remaining space */
.voice-viz {
    flex: 1 1 auto;
    min-width: 0;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
}

.voice-viz__bars {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 2px;
    height: 100%;
    width: 100%;
    overflow: hidden;
}

.voice-viz__bar {
    flex: 0 0 2px;
    width: 2px;
    border-radius: 999px;
    background: #6366f1;
    transition: height .08s ease-out;
}

/* Cancel button */
.voice-controls__cancel {
    width: 1.875rem; height: 1.875rem;
    border-radius: 999px;
    display: inline-flex; align-items: center; justify-content: center;
    background: rgba(255,255,255,.08);
    color: var(--t2);
    transition: background .12s, color .12s;
    flex: 0 0 auto;
}
.voice-controls__cancel:hover { background: rgba(255,255,255,.15); color: var(--t1); }

/* Timer */
.voice-controls__timer {
    font-size: .875rem;
    font-weight: 600;
    color: #818cf8;
    letter-spacing: .04em;
    flex: 0 0 auto;
    white-space: nowrap;
}
.voice-controls__timer--loading { color: var(--t3); }

/* Spinner */
.voice-controls__spinner { color: var(--t3); flex: 0 0 auto; display: inline-flex; }

/* Confirm button */
.voice-controls__confirm {
    width: 1.875rem; height: 1.875rem;
    border-radius: 999px;
    display: inline-flex; align-items: center; justify-content: center;
    background: #6366f1;
    color: #fff;
    transition: background .12s;
    flex: 0 0 auto;
}
.voice-controls__confirm:hover { background: #4f46e5; }

/* ── Loading screen ─────────────────────────────────────── */
.taskpane-app--loading { align-items: center; justify-content: center; }
.loading-card {
    width: min(100%, 22rem); padding: 2rem 1.5rem;
    border-radius: var(--r4xl); background: var(--g850);
    border: 1px solid var(--bd2); text-align: center;
}
.loading-card__logo { width: 3.5rem; height: 3.5rem; object-fit: contain; border-radius: 1rem; }
.loading-card__eyebrow { margin-top: .875rem; font-size: .6875rem; color: var(--t3); text-transform: uppercase; letter-spacing: .08em; }
.loading-card__title { margin: .4rem 0 .3rem; font-size: 1.15rem; font-weight: 600; }
.loading-card__message { margin: 0 0 1.125rem; font-size: .875rem; color: var(--t2); line-height: 1.5; }
.loading-card__bar { width: 100%; height: 3px; border-radius: 999px; background: var(--bd2); overflow: hidden; }
.loading-card__bar-fill { display: block; height: 100%; border-radius: inherit; background: var(--acc); animation: bar-slide 1.6s infinite ease-in-out; }
@keyframes bar-slide {
    0%   { transform: translateX(-100%) scaleX(.5); }
    50%  { transform: translateX(30%)   scaleX(1.2); }
    100% { transform: translateX(220%)  scaleX(.5); }
}

/* ── Body layout: main content + (optional) chat-history sidebar ─────────── */
.taskpane-body {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    position: relative;
}
.taskpane-main {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

/* Chat-history sidebar (right). Docked → in-flow column beside content;
   overlay → absolute over content with a backdrop. Always 260px wide. */
.chat-history {
    width: 260px;
    background: #0f0f0f;
    border-left: 1px solid var(--bd2);
    display: flex;
    flex-direction: column;
    min-height: 0;
}
.chat-history--docked { flex: 0 0 260px; }
.chat-history--overlay {
    position: absolute;
    top: 0; right: 0; bottom: 0;
    z-index: 30;
    box-shadow: -8px 0 24px rgba(0,0,0,.45);
}
.chat-history__backdrop {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,.45);
    z-index: 20;
}

.chat-history__header {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .625rem .75rem .5rem;
}
.chat-history__title { font-size: .8125rem; font-weight: 600; color: var(--t1); }
/* Reserved slot for future menu items (e.g. chat search). */
.chat-history__menu { flex: 0 0 auto; }

.chat-history__body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: .25rem .5rem .75rem;
}
.chat-history__body::-webkit-scrollbar       { width: .3rem; }
.chat-history__body::-webkit-scrollbar-thumb { background: rgba(255,255,255,.1); border-radius: 999px; }

.chat-history__section { margin-bottom: .5rem; }
.chat-history__section-toggle {
    display: flex;
    align-items: center;
    gap: .375rem;
    width: 100%;
    padding: .375rem .5rem;
    background: transparent;
    border: none;
    border-radius: .5rem;
    color: var(--t2);
    font-size: .75rem;
    font-weight: 600;
    letter-spacing: .02em;
    text-transform: uppercase;
    cursor: pointer;
}
.chat-history__section-toggle:hover { background: rgba(255,255,255,.06); color: var(--t1); }
.chat-history__chevron { flex: 0 0 auto; transition: transform .12s ease; }
.chat-history__chevron--open { transform: rotate(90deg); }

.chat-history__group { margin: .25rem 0 .5rem; }
.chat-history__group-label {
    font-size: .6875rem;
    font-weight: 600;
    color: var(--t3);
    padding: .25rem .5rem .125rem;
}
.chat-history__item {
    display: flex;
    align-items: center;
    gap: .375rem;
    width: 100%;
    text-align: left;
    padding: .4rem .5rem;
    border: none;
    border-radius: .5rem;
    background: transparent;
    color: var(--t1);
    font-size: .8125rem;
    cursor: pointer;
}
.chat-history__item-title {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* Age pill (last change): same colour as the sidebar background, subtle. */
.chat-history__item-age {
    flex: 0 0 auto;
    background: #0f0f0f;
    color: var(--t3);
    font-size: .6875rem;
    line-height: 1;
    padding: .15rem .4rem;
    border-radius: 999px;
}
.chat-history__item:hover { background: rgba(255,255,255,.06); }
.chat-history__item--active { background: rgba(255,255,255,.10); font-weight: 500; }
.chat-history__empty { padding: .5rem; font-size: .75rem; color: var(--t3); }
.chat-history__empty--error { color: #f87171; }

.icon-btn--active { background: rgba(255,255,255,.10); color: var(--t1); }

/* Projekte (folder tree) inside the history sidebar */
.chat-history__folder-row {
    display: flex;
    align-items: center;
    gap: .375rem;
    width: 100%;
    padding: .375rem .5rem;
    background: transparent;
    border: none;
    border-radius: .5rem;
    color: var(--t1);
    font-size: .8125rem;
    cursor: pointer;
    text-align: left;
}
.chat-history__folder-row:hover { background: rgba(255,255,255,.06); }
.chat-history__folder-icon { flex: 0 0 auto; color: var(--t3); }
.chat-history__folder-name {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.chat-history__folder-children { /* indentation handled inline per depth */ }

/* Section header row: collapsible toggle + hover "+" */
.chat-history__section-head { display: flex; align-items: center; }
.chat-history__section-head .chat-history__section-toggle { flex: 1 1 auto; }
.chat-history__section-add,
.chat-history__folder-add {
    flex: 0 0 auto;
    display: inline-flex; align-items: center; justify-content: center;
    width: 1.5rem; height: 1.5rem;
    border: none; border-radius: .375rem;
    background: transparent; color: var(--t2);
    cursor: pointer;
    opacity: 0; transition: opacity .12s, background .12s, color .12s;
}
.chat-history__section-head:hover .chat-history__section-add,
.chat-history__folder-row:hover .chat-history__folder-add { opacity: 1; }
.chat-history__section-add:hover,
.chat-history__folder-add:hover { background: rgba(255,255,255,.10); color: var(--t1); }

/* Folder row split into twirl / open / add */
.chat-history__folder-row { display: flex; align-items: center; gap: .25rem; padding-right: .25rem; }
.chat-history__folder-twirl {
    flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
    width: 1.1rem; height: 1.5rem; padding: 0;
    background: transparent; border: none; color: var(--t2); cursor: pointer;
}
.chat-history__folder-open {
    flex: 1 1 auto; min-width: 0;
    display: flex; align-items: center; gap: .375rem;
    padding: .375rem .25rem;
    background: transparent; border: none; border-radius: .5rem;
    color: var(--t1); font-size: .8125rem; cursor: pointer; text-align: left;
}
.chat-history__folder-open:hover { background: rgba(255,255,255,.06); }

/* Active project breadcrumb chip in the topbar (greyed, ✕ on hover) */
.project-chip {
    display: inline-flex; align-items: center; gap: .25rem;
    max-width: 11rem;
    padding: .2rem .5rem;
    border-radius: 999px;
    background: var(--g800);
    color: var(--t3);
    font-size: .75rem;
}
.project-chip__label { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.project-chip__remove {
    flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
    width: 1rem; height: 1rem; padding: 0;
    border: none; border-radius: 999px; background: transparent; color: var(--t3);
    cursor: pointer; opacity: 0; transition: opacity .12s, color .12s;
}
.project-chip:hover .project-chip__remove { opacity: 1; }
.project-chip__remove:hover { color: #fff; }

/* Create-project modal (scoped inside the sidebar) */
.chat-history__create-overlay {
    position: absolute; inset: 0; z-index: 40;
    display: flex; align-items: flex-start; justify-content: center;
    padding-top: 3rem;
    background: rgba(0,0,0,.55);
}
.chat-history__create {
    width: 90%; max-width: 240px;
    background: var(--g850); border: 1px solid var(--bd2); border-radius: .75rem;
    padding: .875rem; display: flex; flex-direction: column; gap: .5rem;
}
.chat-history__create-title { font-size: .8125rem; font-weight: 600; color: var(--t1); }
.chat-history__create-input {
    width: 100%; box-sizing: border-box;
    padding: .45rem .6rem;
    background: var(--g900); border: 1px solid var(--bd2); border-radius: .5rem;
    color: var(--t1); font-size: .8125rem;
}
.chat-history__create-desc { resize: vertical; font-family: inherit; }
.chat-history__create-actions { display: flex; justify-content: flex-end; gap: .5rem; }
.chat-history__btn {
    padding: .4rem .75rem; border-radius: .5rem; border: 1px solid var(--bd2);
    background: transparent; color: var(--t1); font-size: .8125rem; cursor: pointer;
}
.chat-history__btn--primary { background: #2563eb; border-color: #2563eb; color: #fff; }
.chat-history__btn:disabled { opacity: .5; cursor: default; }

.chat-history__folder-open--active { background: rgba(255,255,255,.10); font-weight: 500; }
.project-chip__icon { flex: 0 0 auto; }

/* ── History sidebar: visual refinements (colors, compact rows) ──────────── */
.chat-history__section-toggle:hover,
.chat-history__item:hover,
.chat-history__folder-row:hover { background: #161616; }
.chat-history__item--active,
.chat-history__folder-row--active { background: #161616; }
.chat-history__section-add:hover,
.chat-history__folder-add:hover { background: #161616; color: var(--t1); }

/* Project/folder rows: single surface, 34px tall, only the twirl reads as a button.
   The name fills the row and has no separate hover (the row hover covers it). */
.chat-history__folder-row { height: 34px; padding-top: 0; padding-bottom: 0; border-radius: .5rem; }
.chat-history__folder-open {
    background: transparent !important;
    padding-top: 0; padding-bottom: 0;
    height: 100%;
}
.chat-history__folder-open--active { background: transparent; font-weight: 500; }

/* Indent a folder's contents via the container (not per row), with a thin guide line. */
.chat-history__folder-children {
    margin-left: .6rem;
    padding-left: .35rem;
    border-left: 1px solid rgba(255,255,255,.07);
}
.chat-history__folder-row { padding-left: .25rem; }

/* Drag & drop: a chat being dragged + drop-zone highlight (whole folder block incl. children
   / the Chats zone) in a very dark grey. */
.chat-history__item--dragging { opacity: .45; }
.chat-history__folder--drop,
.chat-history__chats-zone--drop,
.chat-history__projects-zone--drop {
    background: #161616;
    border-radius: .5rem;
    box-shadow: inset 0 0 0 1px rgba(255,255,255,.08);
}
/* A folder being dragged shows the grab cursor on its name. */
.chat-history__folder-open[draggable="true"] { cursor: grab; }
`, "",{"version":3,"sources":["webpack://./src/taskpane/taskpane.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;IACI,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,aAAa,OAAO,iBAAiB;IACrC,aAAa,OAAO,mBAAmB;IACvC,aAAa,OAAO,2BAA2B;IAC/C,4BAA4B,IAAI,kBAAkB;IAClD,6BAA6B,GAAG,oBAAoB;IACpD,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,cAAc;IACd,cAAc,MAAM,gCAAgC;IACpD,gFAAgF;AACpF;;AAEA,8DAA8D;AAC9D;IACI,WAAW,EAAE,YAAY;IACzB,SAAS,EAAE,UAAU;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe,YAAY,qBAAqB;IAChD,kBAAkB,SAAS,oBAAoB;IAC/C,mCAAmC;IACnC,kCAAkC;AACtC;AACA,yBAAyB,sBAAsB,EAAE;AACjD,0BAA0B,aAAa,EAAE,cAAc,EAAE;AACzD,SAAS,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE,UAAU,EAAE;AACtE,aAAa,WAAW,EAAE,YAAY,EAAE;;AAExC,8DAA8D;AAC9D;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;AACA,mBAAmB,cAAc,EAAE;;AAEnC,6EAA6E;AAC7E,YAAY,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE;AACxE,kBAAkB,cAAc,EAAE,YAAY,EAAE,YAAY,EAAE,aAAa,EAAE;;AAE7E,6EAA6E;AAC7E;IACI,kCAAkC;IAClC,aAAa,EAAE,sBAAsB;IACrC,YAAY;IACZ,uBAAuB;IACvB,iCAAiC;IACjC,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,uBAAuB;IACvB,kCAAkC;IAClC,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,UAAU;AAClF;AACA,+BAA+B,cAAc,EAAE;AAC/C;IACI,uBAAuB,EAAE,gBAAgB;IACzC,4BAA4B,EAAE,sBAAsB;IACpD,mBAAmB,EAAE,sBAAsB,EAAE,gBAAgB;AACjE;AACA,gCAAgC,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAEzF;IACI,cAAc,EAAE,gBAAgB;IAChC,gBAAgB,EAAE,SAAS,EAAE,cAAc;IAC3C,aAAa,EAAE,sBAAsB,EAAE,UAAU;AACrD;AACA;IACI,2BAA2B,EAAE,oBAAoB;IACjD,uBAAuB;IACvB,sBAAsB;IACtB,aAAa,EAAE,sBAAsB,EAAE,YAAY;AACvD;AACA;IACI,aAAa,EAAE,mBAAmB,EAAE,YAAY;IAChD,WAAW,EAAE,gBAAgB,EAAE,eAAe;IAC9C,qBAAqB,EAAE,wBAAwB;AACnD;AACA,0CAA0C,YAAY,EAAE;AACxD;IACI,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB;IACtF,wBAAwB,EAAE,qBAAqB;IAC/C,gCAAgC,EAAE,cAAc;AACpD;AACA,+BAA+B,mBAAmB,EAAE,gBAAgB,EAAE;;AAEtE;gCACgC,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACrF,gCAAgC,kBAAkB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AACxH;IACI,mBAAmB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,sBAAsB;IACrF,qBAAqB,EAAE,uBAAuB;AAClD;AACA,oCAAoC,+BAA+B,EAAE,cAAc,EAAE,6BAA6B,EAAE;AACpH,oCAAoC,+BAA+B,EAAE,cAAc,EAAE;AACrF,kCAAkC,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAE3F,kCAAkC,aAAa,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACpF;IACI,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,sBAAsB;IACjF,4BAA4B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,wCAAwC;AACrH;AACA,oCAAoC,iCAAiC,EAAE;AACvE,sCAAsC,cAAc,EAAE,gCAAgC,EAAE,cAAc,EAAE;AACxG,4CAA4C,+BAA+B,EAAE;AAC7E,sCAAsC,cAAc,EAAE,gCAAgC,EAAE,cAAc,EAAE;AACxG,4CAA4C,+BAA+B,EAAE;;AAE7E;IACI,cAAc,EAAE,aAAa,EAAE,UAAU;IACzC,uBAAuB,EAAE,+BAA+B;AAC5D;AACA;0CAC0C,cAAc,EAAE;AAC1D,0CAA0C,sBAAsB,EAAE,wBAAwB,EAAE,WAAW,EAAE;AACzG,gDAAgD,uBAAuB,EAAE;;AAEzE,wDAAwD;AACxD,iCAAiC,mBAAmB,EAAE,kBAAkB,EAAE;AAC1E,0CAA0C,cAAc,EAAE;AAC1D,2CAA2C,cAAc,EAAE;AAC3D,wCAAwC,YAAY,EAAE;AACtD,yCAAyC,YAAY,EAAE;;AAEvD,iFAAiF;AACjF;IACI,YAAY;IACZ,mBAAmB;IACnB,iCAAiC;IACjC,aAAa,EAAE,sBAAsB,EAAE,aAAa;AACxD;AACA,sBAAsB,eAAe,EAAE;AACvC;IACI,kBAAkB,EAAE,MAAM,EAAE,QAAQ,EAAE,SAAS;IAC/C,WAAW,EAAE,uCAAuC;AACxD;AACA;IACI,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;IAClF,6BAA6B;AACjC;AACA,qBAAqB,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC9E,oBAAoB,cAAc,EAAE,uBAAuB,EAAE;AAC7D;IACI,WAAW,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,sBAAsB;IAC/E,uBAAuB,EAAE,gBAAgB,EAAE,2BAA2B;AAC1E;AACA;IACI,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,2BAA2B;IAC5E,qBAAqB;IACrB,iDAAiD;AACrD;AACA,6CAA6C,YAAY,EAAE;AAC3D,6CAA6C,uBAAuB,EAAE;AACtE,6CAA6C,gCAAgC,EAAE,oBAAoB,EAAE;AACrG;IACI,cAAc,EAAE,aAAa,EAAE,YAAY;IAC3C,8BAA8B,EAAE,+BAA+B;AACnE;;AAEA,+EAA+E;AAC/E,WAAW,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,sBAAsB,EAAE,UAAU,EAAE;AACvG;IACI,aAAa,EAAE,sBAAsB,EAAE,WAAW;IAClD,kCAAkC,EAAE,oBAAoB;IACxD,uBAAuB,EAAE,2BAA2B;IACpD,6BAA6B;AACjC;AACA,oBAAoB,YAAY,EAAE;AAClC,qBAAqB,YAAY,EAAE;AACnC,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE;AACnE,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACvE;IACI,mBAAmB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,qBAAqB;AACpF;AACA,uBAAuB,gBAAgB,EAAE;AACzC,mBAAmB,cAAc,EAAE;AACnC;IACI,cAAc,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClF,cAAc,EAAE,eAAe,EAAE,qBAAqB,EAAE,gBAAgB;AAC5E;AACA,0BAA0B,iCAAiC,EAAE,gBAAgB,EAAE;AAC/E,yBAAyB,+BAA+B,EAAE;AAC1D,+BAA+B,yBAAyB,EAAE;;AAE1D,gFAAgF;AAChF,sBAAsB,iBAAiB,EAAE;AACzC;IACI,oBAAoB,EAAE,mBAAmB,EAAE,YAAY;IACvD,qBAAqB,EAAE,oBAAoB;IAC3C,2BAA2B,EAAE,uBAAuB,EAAE,gBAAgB;IACtE,iBAAiB;AACrB;AACA,yBAAyB,kDAAkD,EAAE;AAC7E,wBAAwB,iCAAiC,EAAE,gBAAgB,EAAE;AAC7E,wBAAwB,cAAc,EAAE;AACxC,yBAAyB,gBAAgB,EAAE;AAC3C;IACI,kBAAkB,EAAE,wBAAwB,EAAE,sBAAsB;IACpE,iCAAiC,EAAE,gBAAgB;AACvD;AACA,+BAA+B,+BAA+B,EAAE,cAAc,EAAE;AAChF;IACI,WAAW,sCAAsC,EAAE,uBAAuB,EAAE;IAC5E,WAAW,0CAA0C,EAAE,wBAAwB,EAAE;AACrF;;AAEA,6EAA6E;AAC7E,YAAY,kBAAkB,EAAE;AAChC;IACI,kBAAkB;IAClB,UAAU,EAAE,WAAW;IACvB,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,qCAAqC;IACrC,aAAa,EAAE,sBAAsB;IACrC,gBAAgB,EAAE,gBAAgB;AACtC;AACA;IACI,aAAa,EAAE,mBAAmB,EAAE,UAAU;IAC9C,sBAAsB,EAAE,kCAAkC;IAC1D,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB;AAC3D;AACA,8BAA8B,cAAc,EAAE;AAC9C,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,YAAY,EAAE;AAC9F;IACI,gBAAgB,EAAE,sBAAsB,EAAE,oBAAoB;IAC9D,kBAAkB,EAAE,gBAAgB;AACxC;AACA,6BAA6B,iCAAiC,EAAE;;AAEhE,uBAAuB,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,UAAU,EAAE;AAC5F;;IAEI,WAAW,EAAE,sBAAsB;IACnC,sBAAsB,EAAE,oBAAoB;IAC5C,uBAAuB,EAAE,4BAA4B,EAAE,gBAAgB;IACvE,kBAAkB;AACtB;AACA,6BAA6B,wBAAwB,EAAE;;AAEvD;IACI,cAAc,EAAE,gBAAgB;IAChC,cAAc,EAAE,aAAa,EAAE,sBAAsB,EAAE,YAAY;AACvE;AACA;IACI,aAAa,EAAE,uBAAuB,EAAE,UAAU;IAClD,gBAAgB,EAAE,sBAAsB,EAAE,oBAAoB;IAC9D,2BAA2B,EAAE,uBAAuB;AACxD;AACA,gCAAgC,iCAAiC,EAAE;AACnE,oCAAoC,wBAAwB,EAAE,gCAAgC,EAAE;AAChG;IACI,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,iBAAiB;IAC5D,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,qBAAqB,EAAE,4BAA4B;IACnD,mBAAmB,EAAE,WAAW;AACpC;AACA,6DAA6D,sBAAsB,EAAE,wBAAwB,EAAE;AAC/G,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,YAAY,EAAE;AAC7F,0BAA0B,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACnF;IACI,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB;IACrD,oBAAoB,EAAE,qBAAqB,EAAE,4BAA4B,EAAE,gBAAgB;AAC/F;AACA,wBAAwB,aAAa,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAClG,+BAA+B,cAAc,EAAE;;AAE/C,yBAAyB,gBAAgB,EAAE,+BAA+B,EAAE;AAC5E;IACI,WAAW,EAAE,cAAc,EAAE,oBAAoB;IACjD,sBAAsB,EAAE,WAAW,EAAE,mBAAmB,EAAE,gBAAgB;IAC1E,4BAA4B;AAChC;AACA,mCAAmC,WAAW,EAAE,eAAe,EAAE;AACjE,+CAA+C,uBAAuB,EAAE;;AAExE,8DAA8D;AAC9D;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,oFAAoF;IACpF,mDAAmD;IACnD,uBAAuB;IACvB,kCAAkC;IAClC,cAAc;IACd,mBAAmB;AACvB;AACA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AAChG,oBAAoB,cAAc,EAAE,EAAE,0CAA0C;AAChF,8BAA8B,cAAc,EAAE,GAAG,oCAAoC;AACrF,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE,cAAc,EAAE;;AAEnF,mFAAmF;AACnF;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;AACA,mBAAmB,gBAAgB,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACpE,qBAAqB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACrF,oBAAoB,cAAc,EAAE,gBAAgB,EAAE,YAAY,oBAAoB;AACtF,oBAAoB,cAAc,EAAE,YAAY,EAAE,gBAAgB,EAAE,EAAE,qBAAqB;AAC3F,oBAAoB,gBAAgB,EAAE,YAAY,EAAE,eAAe,0BAA0B;AAC7F,oBAAoB,iBAAiB,EAAE,YAAY,EAAE,aAAa,oBAAoB;AACtF;IACI,cAAc;IACd,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,UAAU;IAC1D,YAAY,EAAE,oBAAoB,EAAE,uBAAuB,EAAE,gBAAgB;IAC7E,eAAe,EAAE,UAAU,EAAE,oCAAoC;AACrE;AACA,wCAAwC,UAAU,EAAE;AACpD,4BAA4B,WAAW,EAAE;;AAEzC,uBAAuB;AACvB;IACI,eAAe,EAAE,gBAAgB;IACjC,oBAAoB;IACpB,uBAAuB;IACvB,4BAA4B;IAC5B,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB;IACvD,eAAe,EAAE,cAAc;AACnC;;AAEA;IACI,eAAe,EAAE,gBAAgB;IACjC,oBAAoB;IACpB,iBAAiB;IACjB,4BAA4B;IAC5B,cAAc;IACd,eAAe,EAAE,cAAc;AACnC;;AAEA,8DAA8D;AAC9D,aAAa,kBAAkB,EAAE;;AAEjC;IACI,oBAAoB,EAAE,mBAAmB,EAAE,UAAU;IACrD,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB,EAAE,gBAAgB;IACrC,2BAA2B;IAC3B,mBAAmB;AACvB;AACA,4BAA4B,iCAAiC,EAAE;;AAE/D,mBAAmB,cAAc,EAAE;;AAEnC;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;AAClB;AACA,4BAA4B,yBAAyB,EAAE;;AAEvD,8DAA8D;AAC9D;IACI,kBAAkB;IAClB,yBAAyB;IACzB,OAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,qCAAqC;IACrC,gBAAgB;IAChB,aAAa,EAAE,sBAAsB;AACzC;;AAEA,eAAe;AACf;IACI,aAAa,EAAE,mBAAmB,EAAE,UAAU;IAC9C,wBAAwB;IACxB,kCAAkC;AACtC;AACA,0BAA0B,cAAc,EAAE,gBAAgB,EAAE;AAC5D;IACI,OAAO,EAAE,gBAAgB,EAAE,YAAY,EAAE,aAAa;IACtD,kBAAkB,EAAE,gBAAgB;IACpC,gBAAgB;AACpB;AACA,kCAAkC,gBAAgB,EAAE;;AAEpD,kBAAkB;AAClB;IACI,aAAa,EAAE,mBAAmB,EAAE,MAAM;IAC1C,sBAAsB;IACtB,kCAAkC;IAClC,gBAAgB;IAChB,qBAAqB;AACzB;AACA,sCAAsC,aAAa,EAAE;;AAErD;IACI,cAAc;IACd,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB,EAAE,gBAAgB;IACrC,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;AAC3C;AACA,wBAAwB,gBAAgB,EAAE;AAC1C;IACI,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,aAAa,EAAE,mBAAmB,EAAE,YAAY;IAChD,WAAW,EAAE,sBAAsB;IACnC,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB,EAAE,gBAAgB;IACpC,0BAA0B;AAC9B;AACA,yBAAyB,iCAAiC,EAAE;AAC5D,2BAA2B,iCAAiC,EAAE;;AAE9D;IACI,eAAe,EAAE,gBAAgB;IACjC,cAAc;IACd,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,gBAAgB;AACpB;AACA,sEAAsE;AACtE;IACI,eAAe,EAAE,gBAAgB;IACjC,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc,EAAE,YAAY;IAC5B,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;IAC9D,gBAAgB;AACpB;AACA,2EAA2E;AAC3E;IACI,cAAc;IACd,oBAAoB,EAAE,mBAAmB;IACzC,gBAAgB;IAChB,YAAY;AAChB;AACA,yBAAyB,gBAAgB,EAAE;AAC3C;IACI,cAAc,EAAE,gBAAgB;IAChC,oBAAoB,EAAE,mBAAmB;AAC7C;AACA,oBAAoB,cAAc,EAAE,gBAAgB,EAAE;;AAEtD,8DAA8D;AAC9D;IACI,mBAAmB,EAAE,gBAAgB;IACrC,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,UAAU;IACV,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB,EAAE,iBAAiB;AAC1C;AACA,kBAAkB,iCAAiC,EAAE,gBAAgB,EAAE;AACvE,gBAAgB,cAAc,EAAE;;AAEhC,8DAA8D;AAC9D;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,8DAA8D;AAC9D;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;IACrB,iDAAiD;AACrD;AACA,yCAAyC,YAAY,EAAE;AACvD,yCAAyC,uBAAuB,EAAE;AAClE,yCAAyC,gCAAgC,EAAE,oBAAoB,EAAE;;AAEjG,8DAA8D;AAC9D;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,2BAA2B;IAC3B,WAAW,EAAE,YAAY;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;IAChB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,oCAAoC;IACpC,+CAA+C;IAC/C,WAAW;IACX,uCAAuC;AAC3C;AACA,oBAAoB,uBAAuB,EAAE,gBAAgB,EAAE;AAC/D;IACI,UAAU,yCAAyC,KAAK;IACxD,UAAU,2CAA2C,GAAG;AAC5D;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW,IAAI,0CAA0C;IACzD,WAAW;AACf;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;AACnB;AACA,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;AACzD;IACI,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB;IACrD,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;IAC9D,eAAe;AACnB;AACA,uBAAuB,mBAAmB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACnF;IACI,kEAAkE;IAClE,uBAAuB;IACvB,0DAA0D;IAC1D,sBAAsB,MAAM,cAAc;IAC1C,cAAc;IACd,gBAAgB;IAChB,mBAAmB,SAAS,+BAA+B;IAC3D,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA,0CAA0C;AAC1C;IACI,eAAe,EAAE,gBAAgB;IACjC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,gBAAgB;AACpB;AACA,kBAAkB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAEhE;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,wBAAwB;AAC5B;;AAEA,8DAA8D;AAC9D,4BAA4B,mBAAmB,EAAE;;AAEjD,wDAAwD;AACxD;IACI,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA,6CAA6C;AAC7C;4CAC4C,UAAU,EAAE;;AAExD,8DAA8D;AAC9D;IACI,UAAU;IACV,gCAAgC,IAAI,sCAAsC;IAC1E,mBAAmB;IACnB,iBAAiB,WAAW,0DAA0D;IACtF,sBAAsB;IACtB,mBAAmB,SAAS,gDAAgD;IAC5E,WAAW;AACf;;AAEA,uCAAuC;AACvC,cAAc,iBAAiB,EAAE;AACjC,yBAAyB,gBAAgB,EAAE;;AAE3C,iBAAiB;AACjB;IACI,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;AACA,eAAe,oBAAoB,EAAE;AACrC,uCAAuC,0BAA0B,EAAE;;AAEnE,aAAa;AACb;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;AACA,+EAA+E,aAAa,EAAE;AAC9F,eAAe,gBAAgB,EAAE;AACjC,eAAe,iBAAiB,EAAE;AAClC,eAAe,iBAAiB,EAAE;AAClC,2CAA2C,cAAc,EAAE;;AAE3D,UAAU;AACV,cAAc,WAAW,EAAE,0BAA0B,EAAE;;AAEvD;8CAC8C;AAC9C;;;;;;;;;;eAUe,WAAW,EAAE;;AAE5B,aAAa;AACb,mBAAmB,gBAAgB,EAAE;AACrC,eAAe,kBAAkB,EAAE;AACnC,gBAAgB,WAAW,EAAE;;AAE7B,wBAAwB;AACxB;IACI,gFAAgF;IAChF,gBAAgB;IAChB,oCAAoC;IACpC,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA,+CAA+C;AAC/C;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA,qBAAqB,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE;AACzF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;AACtB;AACA,0BAA0B,gBAAgB,EAAE,oCAAoC,EAAE;AAClF,wBAAwB,cAAc,EAAE;AACxC,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACjD,0BAA0B,cAAc,EAAE;AAC1C,wFAAwF;AACxF,wBAAwB,+BAA+B,EAAE;AACzD,6CAA6C,yBAAyB,EAAE;AACxE,+DAA+D;AAC/D;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA,yCAAyC,aAAa,EAAE;AACxD,4CAA4C,cAAc,EAAE;AAC5D,iGAAiG;AACjG,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;AAC1D;IACI,gFAAgF;IAChF,iBAAiB;AACrB;AACA,kCAAkC,aAAa,EAAE;AACjD,0FAA0F;AAC1F;;wBAEwB,yBAAyB,EAAE;AACnD,kFAAkF;AAClF,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,qBAAqB,EAAE;;AAE/C,yDAAyD;AACzD;IACI,eAAe;IACf,sCAAsC;AAC1C;AACA,sCAAsC,oCAAoC,EAAE;AAC5E;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,cAAc;IACd,kBAAkB;IAClB,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,YAAY;IACZ,6CAA6C;IAC7C,aAAa;AACjB;;AAEA;gCACgC;AAChC;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kCAAkC,IAAI,6BAA6B;AACvE;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,mCAAmC;AACvC;AACA,mCAAmC,mBAAmB,EAAE;AACxD,2BAA2B,oCAAoC,EAAE;;AAEjE,4EAA4E;AAC5E;oDACoD,mBAAmB,EAAE;;AAEzE;;;+CAG+C;AAC/C,iBAAiB,kBAAkB,EAAE;AACrC;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,WAAW;IACX,oBAAoB,IAAI,wDAAwD;AACpF;AACA;IACI,gBAAgB;IAChB,QAAQ;IACR,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,qDAAqD;AACzD;AACA;+BAC+B,UAAU,EAAE;AAC3C,uBAAuB,uBAAuB,EAAE,gBAAgB,EAAE;AAClE,yBAAyB,cAAc,EAAE,UAAU,EAAE;;AAErD,mBAAmB;AACnB,sCAAsC,kBAAkB,EAAE;AAC1D,kDAAkD,gBAAgB,EAAE,oBAAoB,EAAE;;AAE1F,kBAAkB;AAClB,gBAAgB,eAAe,EAAE,kBAAkB,EAAE;;AAErD,mEAAmE;AACnE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB,IAAI,oDAAoD;IACjF,iBAAiB;IACjB,0BAA0B;IAC1B,aAAa;IACb,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,oCAAoC;IACpC,8BAA8B;IAC9B,uCAAuC;AAC3C;AACA,qBAAqB,WAAW,EAAE,oCAAoC,EAAE;AACxE;IACI,mBAAmB,IAAI,kDAAkD;AAC7E;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA,8DAA8D;AAC9D;IACI,wBAAwB;IACxB,sBAAsB;IACtB,0CAA0C;IAC1C,oCAAoC;IACpC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc,GAAG,eAAe;IAChC,2BAA2B;AAC/B;AACA,gCAAgC,mCAAmC,EAAE;;AAErE;IACI,6CAA6C;IAC7C,cAAc;AAClB;AACA,2BAA2B,KAAK,yBAAyB,EAAE,EAAE;;AAE7D,yBAAyB,OAAO,EAAE,gBAAgB,EAAE;;AAEpD;IACI,cAAc;IACd,0BAA0B;IAC1B,cAAc;AAClB;AACA,iCAAiC,yBAAyB,EAAE;;AAE5D;IACI,8BAA8B;IAC9B,8CAA8C;IAC9C,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;AACA,iBAAiB,iCAAiC,EAAE;;AAEpD;IACI,aAAa;IACb,UAAU,EAAE,WAAW;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;AACnC;AACA,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,gCAAgC,EAAE;AACpE,kCAAkC,qBAAqB,EAAE;AACzD,oCAAoC,gCAAgC,EAAE;;AAEtE;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;AACvB;AACA,kCAAkC,cAAc,EAAE,oCAAoC,EAAE,iBAAiB,EAAE;AAC3G,kCAAkC,gBAAgB,EAAE,iBAAiB,EAAE;AACvE,kCAAkC,gBAAgB,EAAE,kBAAkB,EAAE;;AAExE,2BAA2B;AAC3B;IACI,eAAe;IACf,aAAa;IACb,2BAA2B;IAC3B,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA,0DAA0D;AAC1D;IACI,UAAU;IACV,wBAAwB;AAC5B;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc,EAAE,eAAe;IAC/B,sBAAsB;IACtB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,gBAAgB;IAChB,uCAAuC;AAC3C;AACA,wBAAwB,WAAW,EAAE,iCAAiC,EAAE;;AAExE,8DAA8D;AAC9D;IACI,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;AACA,0FAA0F;AAC1F;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;AACA,6CAA6C,cAAc,EAAE;AAC7D;+EAC+E;AAC/E;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,2BAA2B;IAC3B,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,YAAY;IACZ,UAAU;IACV,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,kGAAkG;AACtG;AACA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;AACA,mCAAmC,iCAAiC,EAAE,gBAAgB,EAAE;AACxF;;4DAE4D;AAC5D;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA,+DAA+D;AAC/D;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;AACA,gDAAgD;AAChD,2CAA2C,aAAa,EAAE;;AAE1D,iDAAiD;AACjD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,2BAA2B;IAC3B,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uCAAuC;AAC3C;AACA,+BAA+B,iCAAiC,EAAE,gBAAgB,EAAE;;AAEpF;IACI,oBAAoB;IACpB,mBAAmB;AACvB;AACA,mCAAmC,iBAAiB,EAAE;AACtD;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,cAAc;IACd,6BAA6B;IAC7B,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA,iDAAiD,WAAW,EAAE;AAC9D,mFAAmF;AACnF;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;AACA,oCAAoC,cAAc,EAAE;AACpD;oEACoE;AACpE;IACI,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;AACA,gCAAgC,cAAc,EAAE;AAChD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,6BAA6B;IAC7B,uBAAuB;AAC3B;AACA,6BAA6B,eAAe,EAAE;;AAE9C,4EAA4E;AAC5E;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,2CAA2C;IAC3C,cAAc,2BAA2B,YAAY;IACrD,mCAAmC,MAAM,eAAe;IACxD,yCAAyC,EAAE,eAAe;AAC9D;AACA,yBAAyB,kCAAkC,EAAE,EAAE,cAAc;AAC7E,0BAA0B,cAAc,EAAE;AAC1C;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;AACA,6CAA6C,oBAAoB,EAAE;;AAEnE,4DAA4D;AAC5D;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;AACA,wCAAwC;AACxC,kCAAkC,oBAAoB,EAAE,iBAAiB,EAAE;;AAE3E,iFAAiF;AACjF;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;AACvB;AACA,oCAAoC,aAAa,EAAE,cAAc,EAAE;AACnE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,wBAAwB;AAC5B;AACA;iCACiC,UAAU,EAAE;;AAE7C,iEAAiE;AACjE;IACI,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;AACd;AACA,wBAAwB,aAAa,EAAE,UAAU,EAAE;AACnD;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,oDAAoD;AACxD;AACA,6BAA6B,uBAAuB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;AAClG,mCAAmC,oCAAoC,EAAE;AACzE,4BAA4B,uBAAuB,EAAE,WAAW,EAAE;AAClE,kCAAkC,gBAAgB,EAAE;AACpD,+BAA+B,gBAAgB,EAAE,WAAW,EAAE;AAC9D,qCAAqC,uBAAuB,EAAE;AAC9D;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,uCAAuC;AAC3C;AACA,6CAA6C,oCAAoC,EAAE,WAAW,EAAE;AAChG,iCAAiC,YAAY,EAAE,eAAe,EAAE;AAChE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,8DAA8D;AAC9D;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,8BAA8B,IAAI,eAAe;IACjD,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,4BAA4B;IAC5B,gCAAgC;IAChC,gBAAgB;IAChB,yCAAyC;AAC7C;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB,IAAI,8BAA8B;IACnD,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;AACA,mBAAmB,WAAW,EAAE,YAAY,EAAE;AAC9C;IACI,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,oDAAoD;AACxD;AACA,oBAAoB,kBAAkB,EAAE;AACxC,oBAAoB,uBAAuB,EAAE,gBAAgB,EAAE;AAC/D,0BAA0B,uBAAuB,EAAE;AACnD,sBAAsB,mBAAmB,EAAE,WAAW,EAAE;AACxD,4BAA4B,wBAAwB,EAAE;AACtD,uBAAuB,gBAAgB,EAAE,WAAW,EAAE;AACtD,6BAA6B,uBAAuB,EAAE;;AAEtD,8DAA8D;AAC9D;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB,QAAQ,YAAY;IACtC,iBAAiB,SAAS,iBAAiB;IAC3C,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,wBAAwB;AAC5B;AACA,sBAAsB,YAAY,EAAE;;AAEpC,8DAA8D;AAC9D,eAAe,oBAAoB,EAAE,mBAAmB,EAAE,UAAU,EAAE,gBAAgB,EAAE;AACxF;IACI,UAAU,EAAE,WAAW;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,8CAA8C;AAClD;AACA,2BAA2B,oBAAoB,EAAE;AACjD,2BAA2B,oBAAoB,EAAE;AACjD;IACI,cAAc,WAAW,EAAE,oBAAoB,EAAE;IACjD,cAAc,UAAU,GAAG,mBAAmB,GAAG;AACrD;;AAEA,8DAA8D;AAC9D;IACI,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa,EAAE,sBAAsB,EAAE,uBAAuB;IAC9D,UAAU,EAAE,wBAAwB;IACpC,0BAA0B;IAC1B,4BAA4B;IAC5B,uBAAuB;IACvB,gBAAgB;IAChB,8CAA8C;IAC9C,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACrD;AACA,4BAA4B,uBAAuB,EAAE,kCAAkC,EAAE;AACzF,wBAAwB,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACnG;IACI,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB;IACvD,oBAAoB,EAAE,qBAAqB;IAC3C,4BAA4B,EAAE,gBAAgB;AAClD;;AAEA,8DAA8D;AAC9D,YAAY,cAAc,EAAE,2BAA2B,EAAE;;AAEzD,gDAAgD;AAChD;IACI,aAAa,EAAE,sBAAsB;IACrC,mBAAmB,EAAE,SAAS;IAC9B,4BAA4B;AAChC;AACA;IACI,aAAa,EAAE,sBAAsB;IACrC,mBAAmB,EAAE,UAAU;IAC/B,kBAAkB;AACtB;AACA;IACI,cAAc,EAAE,eAAe;IAC/B,sBAAsB,EAAE,gBAAgB;IACxC,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,gBAAgB;IAChB,oBAAoB,EAAE,cAAc;AACxC;AACA,4BAA4B,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC5E;IACI,SAAS,EAAE,kBAAkB,EAAE,gBAAgB;IAC/C,gBAAgB,EAAE,iBAAiB;AACvC;AACA;IACI,SAAS,EAAE,mBAAmB,EAAE,gBAAgB;IAChD,gBAAgB,EAAE,gBAAgB;AACtC;;AAEA,mDAAmD;AACnD;IACI,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B,KAAK,+BAA+B;IAC9D,4BAA4B;IAC5B,aAAa,EAAE,sBAAsB,EAAE,UAAU;IACjD,6BAA6B;AACjC;AACA;8BAC8B,wBAAwB,EAAE;;AAExD;IACI,WAAW;IACX,kBAAkB,EAAE,gBAAgB;IACpC,YAAY,EAAE,YAAY,EAAE,aAAa;IACzC,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,kDAAkD;AACtD;AACA,mCAAmC,gBAAgB,EAAE;;AAErD;IACI,aAAa,EAAE,mBAAmB;IAClC,8BAA8B,EAAE,YAAY;AAChD;AACA,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE;AAC5E,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,UAAU,EAAE;;AAE3E,uCAAuC;AACvC;IACI,UAAU,EAAE,YAAY;IACxB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB,EAAE,gBAAgB;IACrC,gCAAgC;IAChC,qBAAqB,EAAE,oBAAoB,EAAE,gBAAgB;AACjE;;AAEA,gDAAgD;AAChD;IACI,eAAe,EAAE,gBAAgB;IACjC,oBAAoB;IACpB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,iCAAiC;IACjC,gBAAgB;IAChB,uCAAuC,EAAE,cAAc;AAC3D;AACA,uBAAuB,iCAAiC,EAAE,gBAAgB,EAAE;;AAE5E;IACI,eAAe,EAAE,gBAAgB;IACjC,oBAAoB;IACpB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,qBAAqB,EAAE,kBAAkB;IACzC,yCAAyC,EAAE,cAAc;AAC7D;AACA,2BAA2B,WAAW,EAAE,mBAAmB,EAAE;AAC7D,uCAAuC,mBAAmB,EAAE;;AAE5D;IACI,eAAe,EAAE,gBAAgB;IACjC,oBAAoB;IACpB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,mCAAmC;IACnC,cAAc;IACd,wCAAwC;IACxC,2BAA2B,EAAE,cAAc;AAC/C;AACA,wBAAwB,mCAAmC,EAAE;;AAE7D,0BAA0B;AAC1B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB,mCAAmC;IACnC,wCAAwC;IACxC,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,oBAAoB,EAAE,mBAAmB,EAAE,YAAY;IACvD,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;AACnB;AACA,mBAAmB,cAAc,EAAE,gBAAgB,EAAE;AACrD;IACI,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB;IACrD,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;IAC9D,eAAe;AACnB;AACA,mBAAmB,mBAAmB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC/E;IACI,kBAAkB;IAClB,WAAW,EAAE,aAAa;IAC1B,WAAW,EAAE,YAAY;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB,EAAE,uBAAuB;IAC5C,cAAc;AAClB;AACA,sCAAsC,oBAAoB,EAAE;AAC5D,2BAA2B,mBAAmB,EAAE;;AAEhD,0EAA0E;AAC1E;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;uFACuF;AACvF;IACI,sBAAsB;IACtB,cAAc,YAAY,gDAAgD;IAC1E,YAAY;IACZ,gBAAgB,UAAU,kDAAkD;IAC5E,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,sBAAsB,IAAI,iCAAiC;AAC/D;AACA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA,kCAAkC,cAAc,EAAE;AAClD;IACI,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;AACA,sCAAsC,cAAc,EAAE;;AAEtD;6EAC6E;AAC7E;IACI,0DAA0D;AAC9D;AACA;IACI,sDAAsD;AAC1D;;AAEA;oEACoE;AACpE;IACI,0DAA0D;AAC9D;;AAEA,8DAA8D;AAC9D,aAAa,kBAAkB,EAAE;;AAEjC;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;IAChB,aAAa,EAAE,sBAAsB,EAAE,YAAY;AACvD;;AAEA;IACI,aAAa,EAAE,mBAAmB,EAAE,UAAU;IAC9C,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB;IACtD,kCAAkC;IAClC,sBAAsB;AAC1B;AACA,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE,OAAO,EAAE;AACvF;IACI,iBAAiB,EAAE,gBAAgB;IACnC,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB,EAAE,oBAAoB;AAC/C;;AAEA;IACI,aAAa,EAAE,mBAAmB,EAAE,YAAY;IAChD,WAAW,EAAE,sBAAsB;IACnC,oBAAoB;IACpB,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB;IACtD,0BAA0B;AAC9B;AACA,0BAA0B,iCAAiC,EAAE;AAC7D,0BAA0B,8BAA8B,EAAE;AAC1D,yBAAyB,cAAc,EAAE,gBAAgB,EAAE;AAC3D,0BAA0B,OAAO,EAAE;AACnC,0BAA0B,cAAc,EAAE,gBAAgB,EAAE;;AAE5D,kBAAkB;AAClB;IACI,eAAe,EAAE,gBAAgB;IACjC,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;AACA,gBAAgB,qBAAqB,EAAE;AACvC;IACI,kBAAkB;IAClB,WAAW,EAAE,YAAY;IACzB,cAAc,EAAE,eAAe;IAC/B,oBAAoB;IACpB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA,gCAAgC,2BAA2B,EAAE;;AAE7D,8DAA8D;AAC9D;IACI,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,eAAe,MAAM,gDAAgD;AACzE;;AAEA,2CAA2C;AAC3C;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA,kBAAkB;AAClB;IACI,eAAe,EAAE,gBAAgB;IACjC,oBAAoB;IACpB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,iCAAiC;IACjC,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;AAClB;AACA,gCAAgC,iCAAiC,EAAE,gBAAgB,EAAE;;AAErF,UAAU;AACV;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;AACA,kCAAkC,gBAAgB,EAAE;;AAEpD,YAAY;AACZ,2BAA2B,gBAAgB,EAAE,cAAc,EAAE,oBAAoB,EAAE;;AAEnF,mBAAmB;AACnB;IACI,eAAe,EAAE,gBAAgB;IACjC,oBAAoB;IACpB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,mBAAmB;IACnB,WAAW;IACX,2BAA2B;IAC3B,cAAc;AAClB;AACA,iCAAiC,mBAAmB,EAAE;;AAEtD,8DAA8D;AAC9D,yBAAyB,mBAAmB,EAAE,uBAAuB,EAAE;AACvE;IACI,uBAAuB,EAAE,oBAAoB;IAC7C,0BAA0B,EAAE,uBAAuB;IACnD,4BAA4B,EAAE,kBAAkB;AACpD;AACA,sBAAsB,aAAa,EAAE,cAAc,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC/F,yBAAyB,mBAAmB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AACvI,uBAAuB,qBAAqB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACpF,yBAAyB,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACvG,qBAAqB,WAAW,EAAE,WAAW,EAAE,oBAAoB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAC/G,0BAA0B,cAAc,EAAE,YAAY,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,8CAA8C,EAAE;AACxJ;IACI,OAAO,uCAAuC,EAAE;IAChD,OAAO,wCAAwC,EAAE;IACjD,OAAO,uCAAuC,EAAE;AACpD;;AAEA,+EAA+E;AAC/E;IACI,cAAc;IACd,aAAa;IACb,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;wEACwE;AACxE;IACI,YAAY;IACZ,mBAAmB;IACnB,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;AACA,wBAAwB,eAAe,EAAE;AACzC;IACI,kBAAkB;IAClB,MAAM,EAAE,QAAQ,EAAE,SAAS;IAC3B,WAAW;IACX,uCAAuC;AAC3C;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,6BAA6B;AACjC;AACA,uBAAuB,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAChF,4DAA4D;AAC5D,sBAAsB,cAAc,EAAE;;AAEtC;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,4BAA4B;AAChC;AACA,+CAA+C,YAAY,EAAE;AAC7D,+CAA+C,gCAAgC,EAAE,oBAAoB,EAAE;;AAEvG,yBAAyB,oBAAoB,EAAE;AAC/C;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;AACnB;AACA,sCAAsC,iCAAiC,EAAE,gBAAgB,EAAE;AAC3F,yBAAyB,cAAc,EAAE,+BAA+B,EAAE;AAC1E,+BAA+B,wBAAwB,EAAE;;AAEzD,uBAAuB,sBAAsB,EAAE;AAC/C;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA,2EAA2E;AAC3E;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,oBAAoB;AACxB;AACA,4BAA4B,iCAAiC,EAAE;AAC/D,8BAA8B,iCAAiC,EAAE,gBAAgB,EAAE;AACnF,uBAAuB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC5E,8BAA8B,cAAc,EAAE;;AAE9C,oBAAoB,iCAAiC,EAAE,gBAAgB,EAAE;;AAEzE,sDAAsD;AACtD;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA,kCAAkC,iCAAiC,EAAE;AACrE,6BAA6B,cAAc,EAAE,gBAAgB,EAAE;AAC/D;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA,iCAAiC,yCAAyC,EAAE;;AAE5E,uDAAuD;AACvD,8BAA8B,aAAa,EAAE,mBAAmB,EAAE;AAClE,4DAA4D,cAAc,EAAE;AAC5E;;IAEI,cAAc;IACd,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClE,aAAa,EAAE,cAAc;IAC7B,YAAY,EAAE,sBAAsB;IACpC,uBAAuB,EAAE,gBAAgB;IACzC,eAAe;IACf,UAAU,EAAE,qDAAqD;AACrE;AACA;4DAC4D,UAAU,EAAE;AACxE;kCACkC,iCAAiC,EAAE,gBAAgB,EAAE;;AAEvF,6CAA6C;AAC7C,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AACpG;IACI,cAAc,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClF,aAAa,EAAE,cAAc,EAAE,UAAU;IACzC,uBAAuB,EAAE,YAAY,EAAE,gBAAgB,EAAE,eAAe;AAC5E;AACA;IACI,cAAc,EAAE,YAAY;IAC5B,aAAa,EAAE,mBAAmB,EAAE,YAAY;IAChD,uBAAuB;IACvB,uBAAuB,EAAE,YAAY,EAAE,oBAAoB;IAC3D,gBAAgB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB;AAC5E;AACA,mCAAmC,iCAAiC,EAAE;;AAEtE,sEAAsE;AACtE;IACI,oBAAoB,EAAE,mBAAmB,EAAE,WAAW;IACtD,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,uBAAuB,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACvF;IACI,cAAc,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;IAClF,WAAW,EAAE,YAAY,EAAE,UAAU;IACrC,YAAY,EAAE,oBAAoB,EAAE,uBAAuB,EAAE,gBAAgB;IAC7E,eAAe,EAAE,UAAU,EAAE,oCAAoC;AACrE;AACA,4CAA4C,UAAU,EAAE;AACxD,8BAA8B,WAAW,EAAE;;AAE3C,qDAAqD;AACrD;IACI,kBAAkB,EAAE,QAAQ,EAAE,WAAW;IACzC,aAAa,EAAE,uBAAuB,EAAE,uBAAuB;IAC/D,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,UAAU,EAAE,gBAAgB;IAC5B,uBAAuB,EAAE,4BAA4B,EAAE,qBAAqB;IAC5E,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,UAAU;AACvE;AACA,8BAA8B,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACvF;IACI,WAAW,EAAE,sBAAsB;IACnC,qBAAqB;IACrB,uBAAuB,EAAE,4BAA4B,EAAE,oBAAoB;IAC3E,gBAAgB,EAAE,mBAAmB;AACzC;AACA,6BAA6B,gBAAgB,EAAE,oBAAoB,EAAE;AACrE,gCAAgC,aAAa,EAAE,yBAAyB,EAAE,UAAU,EAAE;AACtF;IACI,qBAAqB,EAAE,oBAAoB,EAAE,4BAA4B;IACzE,uBAAuB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,eAAe;AACnF;AACA,8BAA8B,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AACvF,8BAA8B,WAAW,EAAE,eAAe,EAAE;;AAE5D,qCAAqC,iCAAiC,EAAE,gBAAgB,EAAE;AAC1F,sBAAsB,cAAc,EAAE;;AAEtC,+EAA+E;AAC/E;;kCAEkC,mBAAmB,EAAE;AACvD;oCACoC,mBAAmB,EAAE;AACzD;kCACkC,mBAAmB,EAAE,gBAAgB,EAAE;;AAEzE;gFACgF;AAChF,4BAA4B,YAAY,EAAE,cAAc,EAAE,iBAAiB,EAAE,oBAAoB,EAAE;AACnG;IACI,kCAAkC;IAClC,cAAc,EAAE,iBAAiB;IACjC,YAAY;AAChB;AACA,qCAAqC,uBAAuB,EAAE,gBAAgB,EAAE;;AAEhF,wFAAwF;AACxF;IACI,kBAAkB;IAClB,oBAAoB;IACpB,4CAA4C;AAChD;AACA,4BAA4B,oBAAoB,EAAE;;AAElD;2CAC2C;AAC3C,gCAAgC,YAAY,EAAE;AAC9C;;;IAGI,mBAAmB;IACnB,oBAAoB;IACpB,iDAAiD;AACrD;AACA,8DAA8D;AAC9D,+CAA+C,YAAY,EAAE","sourcesContent":["/*\n * Tokens — Open WebUI gray scale (oklch → hex)\n * gray-800 #333  gray-850 #262626  gray-900 #171717  gray-950 #0d0d0d\n * spacing = 0.25rem  radius-2xl=1rem  radius-3xl=1.5rem  radius-4xl=2rem\n * text-sm=0.875rem  text-base=1rem  leading-relaxed=1.625\n */\n:root {\n    --g800: #333333;\n    --g850: #262626;\n    --g900: #171717;\n    --g950: #0d0d0d;\n    --t1: #f5f5f5;      /* text primary */\n    --t2: #a3a3a3;      /* text secondary */\n    --t3: #737373;      /* text muted/placeholder */\n    --bd: rgba(255,255,255,0.08);   /* border normal */\n    --bd2: rgba(255,255,255,0.14);  /* border stronger */\n    --r2xl: 1rem;\n    --r3xl: 1.5rem;\n    --r4xl: 2rem;\n    --acc: #3b82f6;\n    --sky: #0ea5e9;     /* sky-500 for follow-up links */\n    --font: \"Inter\", \"Segoe UI\", ui-sans-serif, system-ui, -apple-system, sans-serif;\n}\n\n/* ── Reset ──────────────────────────────────────────────── */\nhtml, body {\n    width: 100%; height: 100%;\n    margin: 0; padding: 0;\n    background: var(--g900);\n    color: var(--t1);\n    font-family: var(--font);\n    font-size: 1rem;           /* text-base = 16px */\n    line-height: 1.625;        /* leading-relaxed */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n*, *::before, *::after { box-sizing: border-box; }\nbutton, textarea, input { font: inherit; color: inherit; }\nbutton { cursor: pointer; background: none; border: none; padding: 0; }\n#container { width: 100%; height: 100%; }\n\n/* ── App shell ──────────────────────────────────────────── */\n.taskpane-app {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    background: var(--g900);\n    overflow: hidden;\n}\n.taskpane-spacer { flex: 1 1 auto; }\n\n/* ── App-Root: Chat + (optional) Vorschlags-Panel rechts daneben ───────── */\n.app-root { display: flex; width: 100%; height: 100%; overflow: hidden; }\n.app-root__main { flex: 1 1 auto; min-width: 0; height: 100%; display: flex; }\n\n/* ── Änderungsvorschläge — Seitenpanel rechts ──────────────────────────── */\n.change-proposal-panel {\n    flex: 0 0 clamp(15rem, 42%, 22rem);\n    display: flex; flex-direction: column;\n    height: 100%;\n    background: var(--g950);\n    border-left: 1px solid var(--bd2);\n    overflow: hidden;\n}\n.change-proposal-panel__header {\n    flex: 0 0 auto;\n    padding: .625rem .75rem;\n    border-bottom: 1px solid var(--bd);\n    display: flex; align-items: center; justify-content: space-between; gap: .5rem;\n}\n.change-proposal-panel__mode { flex: 0 0 auto; }\n.change-proposal-panel__mode-select {\n    background: var(--g800); color: var(--t2);\n    border: 1px solid var(--bd2); border-radius: .375rem;\n    font-size: .6875rem; padding: .15rem .35rem; max-width: 11rem;\n}\n.change-proposal-panel__title { font-size: .8125rem; font-weight: 600; color: var(--t1); }\n\n.change-proposal-panel__list {\n    flex: 1 1 auto; overflow-y: auto;\n    list-style: none; margin: 0; padding: .5rem;\n    display: flex; flex-direction: column; gap: .5rem;\n}\n.change-proposal-panel__item {\n    border: 1px solid var(--bd); border-radius: .5rem;\n    background: var(--g900);\n    padding: .5rem .625rem;\n    display: flex; flex-direction: column; gap: .375rem;\n}\n.change-proposal-panel__item-head {\n    display: flex; align-items: center; gap: .375rem;\n    width: 100%; text-align: left; cursor: pointer;\n    border-radius: .25rem; transition: opacity .12s;\n}\n.change-proposal-panel__item-head:hover { opacity: .75; }\n.change-proposal-panel__op-badge {\n    font-size: .625rem; font-weight: 600; text-transform: uppercase; letter-spacing: .03em;\n    padding: .125rem .375rem; border-radius: .25rem;\n    background: rgba(59,130,246,.15); color: #93c5fd;\n}\n.change-proposal-panel__para { font-size: .6875rem; color: var(--t3); }\n\n.change-proposal-panel__before,\n.change-proposal-panel__after { display: flex; flex-direction: column; gap: .125rem; }\n.change-proposal-panel__label { font-size: .625rem; text-transform: uppercase; letter-spacing: .03em; color: var(--t3); }\n.change-proposal-panel__text {\n    font-size: .8125rem; line-height: 1.35; white-space: pre-wrap; word-break: break-word;\n    border-radius: .25rem; padding: .25rem .375rem;\n}\n.change-proposal-panel__text--old { background: rgba(239,68,68,.12); color: #fca5a5; text-decoration: line-through; }\n.change-proposal-panel__text--new { background: rgba(34,197,94,.12); color: #86efac; }\n.change-proposal-panel__comment { font-size: .75rem; color: var(--t2); font-style: italic; }\n\n.change-proposal-panel__actions { display: flex; gap: .375rem; margin-top: .125rem; }\n.change-proposal-panel__btn {\n    font-size: .75rem; font-weight: 500; padding: .3rem .5rem; border-radius: .375rem;\n    border: 1px solid var(--bd2); color: var(--t1); background: transparent; transition: background .12s, filter .12s;\n}\n.change-proposal-panel__btn:hover { background: rgba(255,255,255,.07); }\n.change-proposal-panel__btn--accept { flex: 1 1 auto; border-color: rgba(34,197,94,.4); color: #86efac; }\n.change-proposal-panel__btn--accept:hover { background: rgba(34,197,94,.12); }\n.change-proposal-panel__btn--reject { flex: 1 1 auto; border-color: rgba(239,68,68,.4); color: #fca5a5; }\n.change-proposal-panel__btn--reject:hover { background: rgba(239,68,68,.12); }\n\n.change-proposal-panel__bulk-actions {\n    flex: 0 0 auto; display: flex; gap: .5rem;\n    padding: .625rem .75rem; border-top: 1px solid var(--bd);\n}\n.change-proposal-panel__btn--accept-all,\n.change-proposal-panel__btn--reject-all { flex: 1 1 auto; }\n.change-proposal-panel__btn--accept-all { background: var(--acc); border-color: var(--acc); color: #fff; }\n.change-proposal-panel__btn--accept-all:hover { filter: brightness(1.1); }\n\n/* Auflösungs-Status eines Vorschlags (in der Sidebar) */\n.change-proposal-panel__status { font-size: .6875rem; padding: .125rem 0; }\n.change-proposal-panel__status--applied { color: #86efac; }\n.change-proposal-panel__status--rejected { color: #fca5a5; }\n.change-proposal-panel__item--applied { opacity: .72; }\n.change-proposal-panel__item--rejected { opacity: .55; }\n\n/* ── Änderungsvorschläge-Sidebar (rechts; gegenseitig exklusiv zur History) ── */\n.cp-sidebar {\n    width: 260px;\n    background: #0f0f0f;\n    border-left: 1px solid var(--bd2);\n    display: flex; flex-direction: column; min-height: 0;\n}\n.cp-sidebar--docked { flex: 0 0 260px; }\n.cp-sidebar--overlay {\n    position: absolute; top: 0; right: 0; bottom: 0;\n    z-index: 30; box-shadow: -8px 0 24px rgba(0,0,0,.45);\n}\n.cp-sidebar__header {\n    flex: 0 0 auto; display: flex; align-items: center; justify-content: space-between;\n    padding: .625rem .75rem .5rem;\n}\n.cp-sidebar__title { font-size: .8125rem; font-weight: 600; color: var(--t1); }\n.cp-sidebar__mode { display: block; padding: 0 .75rem .5rem; }\n.cp-sidebar__mode-select {\n    width: 100%; font-size: .75rem; padding: .25rem .375rem; border-radius: .375rem;\n    background: var(--g850); color: var(--t1); border: 1px solid var(--bd);\n}\n.cp-sidebar__body {\n    flex: 1 1 auto; min-height: 0; overflow-y: auto; padding: .25rem .5rem .5rem;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255,255,255,.1) transparent;\n}\n.cp-sidebar__body::-webkit-scrollbar       { width: .3rem; }\n.cp-sidebar__body::-webkit-scrollbar-track { background: transparent; }\n.cp-sidebar__body::-webkit-scrollbar-thumb { background: rgba(255,255,255,.1); border-radius: 999px; }\n.cp-sidebar__bulk {\n    flex: 0 0 auto; display: flex; gap: .375rem;\n    padding: .5rem .625rem .625rem; border-top: 1px solid var(--bd);\n}\n\n/* ── Einzelner Vorschlag (Sidebar-Item) ──────────────────────────────────── */\n.cp-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: .5rem; }\n.cp-item {\n    display: flex; flex-direction: column; gap: .25rem;\n    padding: .5rem .5rem .5rem .625rem; border-radius: .5rem;\n    background: var(--g850); border: 1px solid var(--bd);\n    transition: opacity .15s ease;\n}\n.cp-item--applied { opacity: .72; }\n.cp-item--rejected { opacity: .55; }\n.cp-item__head { display: flex; align-items: center; gap: .375rem; }\n.cp-item__num { font-size: .75rem; font-weight: 600; color: var(--t1); }\n.cp-item__jump {\n    font-size: .6875rem; color: var(--t3); padding: 0 .125rem; border-radius: .25rem;\n}\n.cp-item__jump:hover { color: var(--t1); }\n.cp-item__spacer { flex: 1 1 auto; }\n.cp-item__chevron {\n    flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;\n    width: 1.25rem; height: 1.25rem; border-radius: .25rem; color: var(--t2);\n}\n.cp-item__chevron:hover { background: rgba(255,255,255,.07); color: var(--t1); }\n.cp-item__chevron-icon { transition: transform .15s ease; }\n.cp-item__chevron-icon--open { transform: rotate(180deg); }\n\n/* ── Changes-Bullet unter der Assistant-Nachricht (wie eine Quellenangabe) ── */\n.changes-bullet-row { margin-top: .5rem; }\n.changes-bullet {\n    display: inline-flex; align-items: center; gap: .375rem;\n    padding: .25rem .5rem; border-radius: .5rem;\n    border: 1px solid var(--bd); background: var(--g850); color: var(--t2);\n    font-size: .75rem;\n}\n.changes-bullet--blink { animation: changes-bullet-blink 1.4s ease-in-out 2; }\n.changes-bullet:hover { background: rgba(255,255,255,.06); color: var(--t1); }\n.changes-bullet__icon { flex: 0 0 auto; }\n.changes-bullet__count { font-weight: 500; }\n.changes-bullet__badge {\n    font-size: .625rem; padding: .0625rem .25rem; border-radius: .375rem;\n    background: rgba(255,255,255,.08); color: var(--t2);\n}\n.changes-bullet__badge--done { background: rgba(34,197,94,.18); color: #86efac; }\n@keyframes changes-bullet-blink {\n    0%, 100% { box-shadow: 0 0 0 0 rgba(59,130,246,0); border-color: var(--bd); }\n    50%      { box-shadow: 0 0 0 3px rgba(59,130,246,.35); border-color: var(--acc); }\n}\n\n/* ── Quellen-Picker + Wissensquellen-Overlay ───────────────────────────── */\n.composer { position: relative; }\n.composer__source-picker-overlay {\n    position: absolute;\n    left: 1rem; right: 1rem;\n    bottom: calc(100% - .25rem);\n    z-index: 200;\n}\n.source-picker {\n    background: var(--g850);\n    border: 1px solid var(--bd2);\n    border-radius: var(--r2xl);\n    box-shadow: 0 8px 24px rgba(0,0,0,.5);\n    display: flex; flex-direction: column;\n    max-height: 60vh; overflow: hidden;\n}\n.source-picker__header {\n    display: flex; align-items: center; gap: .5rem;\n    padding: .5rem .625rem; border-bottom: 1px solid var(--bd);\n    font-size: .8125rem; font-weight: 600; color: var(--t1);\n}\n.source-picker__header span { flex: 1 1 auto; }\n.source-picker__menu { display: flex; flex-direction: column; padding: .375rem; gap: .125rem; }\n.source-picker__item {\n    text-align: left; padding: .5rem .625rem; border-radius: .5rem;\n    font-size: .875rem; color: var(--t1);\n}\n.source-picker__item:hover { background: rgba(255,255,255,.07); }\n\n.source-picker__body { padding: .625rem; display: flex; flex-direction: column; gap: .5rem; }\n.source-picker__url-input,\n.source-picker__search {\n    width: 100%; box-sizing: border-box;\n    padding: .5rem .625rem; border-radius: .5rem;\n    background: var(--g900); border: 1px solid var(--bd2); color: var(--t1);\n    font-size: .875rem;\n}\n.source-picker__search-row { padding: .5rem .625rem 0; }\n\n.source-picker__kb-list {\n    flex: 1 1 auto; overflow-y: auto;\n    padding: .5rem; display: flex; flex-direction: column; gap: .375rem;\n}\n.source-picker__kb-item {\n    display: flex; align-items: flex-start; gap: .5rem;\n    text-align: left; padding: .5rem .625rem; border-radius: .5rem;\n    border: 1px solid var(--bd); background: var(--g900);\n}\n.source-picker__kb-item:hover { background: rgba(255,255,255,.05); }\n.source-picker__kb-item--selected { border-color: var(--acc); background: rgba(59,130,246,.12); }\n.source-picker__kb-check {\n    flex: 0 0 1rem; width: 1rem; height: 1rem; margin-top: .1rem;\n    display: inline-flex; align-items: center; justify-content: center;\n    border-radius: .25rem; border: 1px solid var(--bd2);\n    font-size: .6875rem; color: #fff;\n}\n.source-picker__kb-item--selected .source-picker__kb-check { background: var(--acc); border-color: var(--acc); }\n.source-picker__kb-body { display: flex; flex-direction: column; gap: .125rem; min-width: 0; }\n.source-picker__kb-name { font-size: .8125rem; font-weight: 500; color: var(--t1); }\n.source-picker__kb-desc {\n    font-size: .75rem; color: var(--t2); line-height: 1.3;\n    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;\n}\n.source-picker__empty { padding: 1rem; text-align: center; color: var(--t3); font-size: .8125rem; }\n.source-picker__empty--error { color: #fca5a5; }\n\n.source-picker__footer { padding: .625rem; border-top: 1px solid var(--bd); }\n.source-picker__add-btn {\n    width: 100%; padding: .5rem; border-radius: .5rem;\n    background: var(--acc); color: #fff; font-size: .8125rem; font-weight: 600;\n    border: 1px solid var(--acc);\n}\n.source-picker__add-btn:disabled { opacity: .5; cursor: default; }\n.source-picker__add-btn:not(:disabled):hover { filter: brightness(1.1); }\n\n/* ── Top bar ────────────────────────────────────────────── */\n.topbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: .5rem;\n    /* +15px right padding so right-aligned items clear Office's info pane (RTL edge). */\n    padding: .375rem calc(.75rem + 15px) .375rem .75rem;\n    background: var(--g900);\n    border-bottom: 1px solid var(--bd);\n    flex: 0 0 auto;\n    min-height: 2.75rem;\n}\n.topbar__left  { display: flex; align-items: center; gap: .25rem; min-width: 0; flex: 1 1 auto; }\n.topbar__left > * { flex: 0 0 auto; } /* model selector etc. keep their size … */\n.topbar__left > .breadcrumb { flex: 1 1 auto; }  /* … the breadcrumb takes the rest */\n.topbar__right { display: flex; align-items: center; gap: .125rem; flex: 0 0 auto; }\n\n/* Active-project breadcrumb — flowing text, priority truncation via flex-shrink. */\n.breadcrumb {\n    display: flex;\n    align-items: center;\n    min-width: 0;\n    overflow: hidden;\n    white-space: nowrap;\n    font-size: .8125rem;\n    color: var(--t3);\n    line-height: 1.2;\n}\n.breadcrumb__sep { color: var(--t3); opacity: .6; margin: 0 .25rem; }\n.breadcrumb > span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.breadcrumb__root { flex: 0 0 auto; color: var(--t2); }           /* always readable */\n.breadcrumb__leaf { flex: 0 1 auto; min-width: 0; color: var(--t2); } /* kept if possible */\n.breadcrumb__mid  { flex: 0 100 auto; min-width: 0; }              /* collapses before leaf */\n.breadcrumb__chat { flex: 0 1000 auto; min-width: 0; }            /* lowest priority */\n.breadcrumb__remove {\n    flex: 0 0 auto;\n    display: inline-flex; align-items: center; justify-content: center;\n    width: 1rem; height: 1rem; margin-left: .25rem; padding: 0;\n    border: none; border-radius: 999px; background: transparent; color: var(--t3);\n    cursor: pointer; opacity: 0; transition: opacity .12s, color .12s;\n}\n.breadcrumb:hover .breadcrumb__remove { opacity: 1; }\n.breadcrumb__remove:hover { color: #fff; }\n\n/* user avatar circle */\n.topbar__avatar {\n    width: 1.875rem; height: 1.875rem;\n    border-radius: 999px;\n    background: var(--g800);\n    border: 1px solid var(--bd2);\n    display: inline-flex; align-items: center; justify-content: center;\n    font-size: .6875rem; font-weight: 600; color: var(--t2);\n    cursor: pointer; flex: 0 0 auto;\n}\n\n.topbar__avatar-img {\n    width: 1.875rem; height: 1.875rem;\n    border-radius: 999px;\n    object-fit: cover;\n    border: 1px solid var(--bd2);\n    display: block;\n    cursor: pointer; flex: 0 0 auto;\n}\n\n/* ── Model selector trigger ─────────────────────────────── */\n.model-sel { position: relative; }\n\n.model-sel__trigger {\n    display: inline-flex; align-items: center; gap: .3rem;\n    padding: .3rem .5rem;\n    border-radius: .5rem;\n    color: var(--t1);\n    font-size: .9375rem; font-weight: 600;\n    transition: background .12s;\n    white-space: nowrap;\n}\n.model-sel__trigger:hover { background: rgba(255,255,255,.07); }\n\n.model-sel__name { line-height: 1; }\n\n.model-sel__chevron {\n    color: var(--t2);\n    transition: transform .15s;\n    flex: 0 0 auto;\n}\n.model-sel__chevron--open { transform: rotate(180deg); }\n\n/* ── Dropdown panel ─────────────────────────────────────── */\n.model-sel__dropdown {\n    position: absolute;\n    top: calc(100% + .375rem);\n    left: 0;\n    z-index: 200;\n    width: min(22rem, 90vw);\n    background: var(--g850);\n    border: 1px solid var(--bd2);\n    border-radius: var(--r2xl);\n    box-shadow: 0 8px 32px rgba(0,0,0,.5);\n    overflow: hidden;\n    display: flex; flex-direction: column;\n}\n\n/* search row */\n.model-sel__search-row {\n    display: flex; align-items: center; gap: .5rem;\n    padding: .625rem .875rem;\n    border-bottom: 1px solid var(--bd);\n}\n.model-sel__search-icon { flex: 0 0 auto; color: var(--t3); }\n.model-sel__search {\n    flex: 1; background: none; border: none; outline: none;\n    font-size: .875rem; color: var(--t1);\n    line-height: 1.5;\n}\n.model-sel__search::placeholder { color: var(--t3); }\n\n/* category tabs */\n.model-sel__tabs {\n    display: flex; align-items: center; gap: 0;\n    padding: .375rem .5rem;\n    border-bottom: 1px solid var(--bd);\n    overflow-x: auto;\n    scrollbar-width: none;\n}\n.model-sel__tabs::-webkit-scrollbar { display: none; }\n\n.model-sel__tab {\n    flex: 0 0 auto;\n    padding: .25rem .625rem;\n    border-radius: .375rem;\n    font-size: .8125rem; font-weight: 500;\n    color: var(--t3);\n    white-space: nowrap;\n    transition: background .12s, color .12s;\n}\n.model-sel__tab:hover { color: var(--t1); }\n.model-sel__tab--active {\n    color: var(--t1);\n    font-weight: 600;\n    /* underline like OpenWebUI */\n    text-decoration: underline;\n    text-underline-offset: .2rem;\n    text-decoration-thickness: 2px;\n}\n\n/* model list */\n.model-sel__list {\n    overflow-y: auto;\n    max-height: 16rem;\n    padding: .375rem;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255,255,255,.1) transparent;\n}\n\n.model-sel__item {\n    display: flex; align-items: center; gap: .625rem;\n    width: 100%; padding: .5rem .625rem;\n    border-radius: .5rem;\n    text-align: left;\n    font-size: .875rem; color: var(--t1);\n    transition: background .1s;\n}\n.model-sel__item:hover { background: rgba(255,255,255,.07); }\n.model-sel__item--active { background: rgba(255,255,255,.07); }\n\n.model-sel__item-icon {\n    width: 1.375rem; height: 1.375rem;\n    flex: 0 0 auto;\n    display: inline-flex; align-items: center; justify-content: center;\n    color: var(--t3);\n}\n/* Model image as a round, edge-filling icon inside the masked slot. */\n.model-sel__item-img {\n    width: 1.375rem; height: 1.375rem;\n    border-radius: 50%;\n    object-fit: cover;\n    display: block;\n}\n\n.model-sel__item-name {\n    flex: 1 1 auto; min-width: 0;\n    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n    font-weight: 500;\n}\n/* Description moved off the line into an info icon with a hover tooltip. */\n.model-sel__info {\n    flex: 0 0 auto;\n    display: inline-flex; align-items: center;\n    color: var(--t3);\n    cursor: help;\n}\n.model-sel__info:hover { color: var(--t1); }\n.model-sel__badge {\n    flex: 0 0 auto; color: var(--t3);\n    display: inline-flex; align-items: center;\n}\n.model-sel__check { flex: 0 0 auto; color: var(--t1); }\n\n/* ── Shared icon button ─────────────────────────────────── */\n.icon-btn {\n    min-width: 1.875rem; height: 1.875rem;\n    padding: 0 .3rem;\n    border-radius: .4rem;\n    display: inline-flex; align-items: center; justify-content: center;\n    gap: .3rem;\n    color: var(--t2);\n    transition: background .12s, color .12s;\n    white-space: nowrap; font-size: .75rem;\n}\n.icon-btn:hover { background: rgba(255,255,255,.08); color: var(--t1); }\n.icon-btn svg { flex: 0 0 auto; }\n\n/* ── Conversation wrap (positions scroll btn) ───────────── */\n.conversation-wrap {\n    flex: 1 1 auto;\n    min-height: 0;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n\n/* ── Conversation scroll area ───────────────────────────── */\n.conversation {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    padding: 1.25rem 2rem .75rem;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255,255,255,.1) transparent;\n}\n.conversation::-webkit-scrollbar       { width: .3rem; }\n.conversation::-webkit-scrollbar-track { background: transparent; }\n.conversation::-webkit-scrollbar-thumb { background: rgba(255,255,255,.1); border-radius: 999px; }\n\n/* ── Scroll-to-bottom button ────────────────────────────── */\n.scroll-btn {\n    position: absolute;\n    bottom: .625rem;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 2rem; height: 2rem;\n    border-radius: 999px;\n    background: var(--g800);\n    border: 1px solid var(--bd2);\n    color: var(--t2);\n    display: inline-flex; align-items: center; justify-content: center;\n    box-shadow: 0 2px 8px rgba(0,0,0,.4);\n    animation: bounce-down .9s ease-in-out infinite;\n    z-index: 10;\n    transition: background .12s, color .12s;\n}\n.scroll-btn:hover { background: var(--g850); color: var(--t1); }\n@keyframes bounce-down {\n    0%,100% { transform: translateX(-50%) translateY(0);    }\n    50%     { transform: translateX(-50%) translateY(4px);  }\n}\n\n/* ── Message list ───────────────────────────────────────── */\n.message-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;   /* clear visual separation between turns */\n    width: 100%;\n}\n\n/* ── User message (right-aligned bubble) ────────────────── */\n.message--user {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: .375rem;\n}\n\n/* file chips row above user bubble */\n.msg-files {\n    display: flex;\n    flex-wrap: wrap;\n    gap: .375rem;\n    justify-content: flex-end;\n}\n\n.msg-file-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: .375rem;\n    padding: .3rem .75rem;\n    border-radius: .625rem;\n    background: var(--g850);\n    border: 1px solid var(--bd2);\n    max-width: 13rem;\n    cursor: default;\n}\n.msg-file-chip__icon { flex: 0 0 auto; color: var(--t3); }\n.msg-file-chip__name {\n    font-size: .75rem; font-weight: 500; color: var(--t1);\n    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n    max-width: 5rem;\n}\n.msg-file-chip__size { font-size: .6875rem; color: var(--t3); white-space: nowrap; }\n.message--user .msg-bubble {\n    /* bg-gray-850, rounded-3xl, px-5 py-2 — straight from OpenWebUI */\n    background: var(--g850);\n    border-radius: var(--r3xl) var(--r3xl) .375rem var(--r3xl);\n    padding: .5rem 1.25rem;     /* py-2 px-5 */\n    max-width: 85%;\n    color: var(--t1);\n    font-size: .9375rem;        /* slightly tighter than base */\n    line-height: 1.6;\n    word-break: break-word;\n    white-space: pre-wrap;\n}\n\n/* ── Assistant message (left, no bubble) ────────────────── */\n.message--assistant {\n    display: flex;\n    flex-direction: column;\n    gap: .375rem;\n    align-items: flex-start;\n    width: 100%;\n}\n\n.msg-header {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n}\n\n/* The two-tone icon from the screenshot */\n.msg-avatar {\n    width: 1.625rem; height: 1.625rem;\n    border-radius: 50%;\n    flex: 0 0 auto;\n    overflow: hidden;\n    display: inline-flex; align-items: center; justify-content: center;\n    background: none;\n}\n.msg-avatar img { width: 100%; height: 100%; object-fit: cover; }\n\n.msg-name {\n    font-size: .9375rem;\n    font-weight: 600;\n    color: var(--t1);\n    line-height: 1;\n}\n\n/* Timestamps — hidden by default, visible on parent hover */\n.msg-timestamp {\n    font-size: .6875rem;\n    color: var(--t3);\n    white-space: nowrap;\n    opacity: 0;\n    transition: opacity .15s;\n}\n\n/* assistant timestamp sits in the header row after the name */\n.msg-timestamp--assistant { margin-left: .25rem; }\n\n/* user timestamp sits above the bubble, right-aligned */\n.msg-timestamp--user {\n    display: block;\n    text-align: right;\n    margin-bottom: .125rem;\n}\n\n/* reveal on hover of the message container */\n.message--assistant:hover .msg-timestamp--assistant,\n.message--user:hover .msg-timestamp--user { opacity: 1; }\n\n/* Assistant body text — matches prose style from screenshot */\n.msg-body {\n    padding: 0;\n    color: oklch(0.872 0.01 258.338);   /* normal paragraph text (assistant) */\n    font-size: .9375rem;\n    line-height: 1.65;          /* slightly tighter than leading-relaxed for narrow pane */\n    word-break: break-word;\n    white-space: normal;        /* markdown is rendered as structured HTML now */\n    width: 100%;\n}\n\n/* paragraphs within body get spacing */\n.msg-body p { margin: 0 0 .75em; }\n.msg-body p:last-child { margin-bottom: 0; }\n\n/* bullet lists */\n.msg-body ul {\n    margin: .25em 0 .75em;\n    padding-left: 1.25rem;\n    list-style: disc;\n}\n.msg-body ol {\n    margin: .25em 0 .75em;\n    padding-left: 1.4rem;\n    list-style: decimal;\n}\n.msg-body li { margin-bottom: .25em; }\n.msg-body li > ul, .msg-body li > ol { margin: .25em 0 .25em 1rem; }\n\n/* headings */\n.msg-body h1, .msg-body h2, .msg-body h3,\n.msg-body h4, .msg-body h5, .msg-body h6 {\n    margin: 1em 0 .4em;\n    line-height: 1.3;\n    font-weight: 600;\n}\n.msg-body h1:first-child, .msg-body h2:first-child, .msg-body h3:first-child { margin-top: 0; }\n.msg-body h1 { font-size: 1.3em; }\n.msg-body h2 { font-size: 1.18em; }\n.msg-body h3 { font-size: 1.06em; }\n.msg-body h4, .msg-body h5, .msg-body h6 { font-size: 1em; }\n\n/* links */\n.msg-body a { color: #fff; text-decoration: underline; }\n\n/* everything that isn't plain paragraph text renders pure white\n   (emphasis, headings, links, code, tables) */\n.msg-body strong,\n.msg-body b,\n.msg-body em,\n.msg-body i,\n.msg-body del,\n.msg-body a,\n.msg-body h1, .msg-body h2, .msg-body h3,\n.msg-body h4, .msg-body h5, .msg-body h6,\n.msg-body code,\n.msg-body th,\n.msg-body td { color: #fff; }\n\n/* emphasis */\n.msg-body strong { font-weight: 600; }\n.msg-body em { font-style: italic; }\n.msg-body del { opacity: .7; }\n\n/* inline + block code */\n.msg-body code {\n    font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n    font-size: .85em;\n    background: rgba(127, 127, 127, .14);\n    padding: .12em .35em;\n    border-radius: 4px;\n}\n.msg-body pre {\n    margin: .5em 0 .8em;\n    padding: .7em .85em;\n    background: rgba(127, 127, 127, .12);\n    border-radius: 8px;\n    overflow-x: auto;\n    white-space: pre;\n}\n.msg-body pre code {\n    background: none;\n    padding: 0;\n    font-size: .85em;\n    white-space: pre;\n}\n/* CodeMirror-Codeblock (read-only, One-Dark) */\n.cm-block {\n    margin: .5em 0 .8em;\n    border: 1px solid var(--bd);\n    border-radius: var(--r3xl);\n    overflow: hidden;\n    background: #000000;\n}\n.cm-block__bar {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n    padding: .5rem .85rem;\n    background: #000000;\n    border-bottom: 1px solid var(--bd);\n}\n.cm-block__lang {\n    font-size: .75rem;\n    color: var(--t1);\n    font-weight: 500;\n}\n.cm-block__actions { margin-left: auto; display: flex; align-items: center; gap: .25rem; }\n.cm-block__action {\n    display: inline-flex;\n    align-items: center;\n    gap: .3rem;\n    color: var(--t2);\n    font-size: .75rem;\n    padding: .2rem .45rem;\n    border-radius: 6px;\n}\n.cm-block__action:hover { color: var(--t1); background: rgba(255, 255, 255, .08); }\n.cm-block__action svg { flex: 0 0 auto; }\n.cm-block__copy svg { width: 14px; height: 14px; }\n.cm-block__copy--copied { color: #86efac; }\n/* Chevron: zeigt nach unten (aufgeklappt = einklappbar); nach oben, wenn eingeklappt. */\n.cm-block__toggle svg { transition: transform .15s ease; }\n.cm-block--collapsed .cm-block__toggle svg { transform: rotate(180deg); }\n/* Collapse-Zustand: Editor aus, „N ausgeblendete Zeilen\" an. */\n.cm-block__collapsed {\n    display: none;\n    padding: .5rem .85rem .7rem;\n    font-size: .8125rem;\n    font-style: italic;\n    color: var(--t3);\n}\n.cm-block--collapsed .cm-block__editor { display: none; }\n.cm-block--collapsed .cm-block__collapsed { display: block; }\n/* Editor erstreckt sich immer voll — keine eigene Scrollbar (Höhe = Inhalt, Zeilen umbrechen). */\n.cm-block .cm-editor { font-size: .8125rem; height: auto; }\n.cm-block .cm-scroller {\n    font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n    overflow: visible;\n}\n.cm-block .cm-editor.cm-focused { outline: none; }\n/* One-Dark setzt den Editor-Hintergrund auf #282c34 — auf reines Schwarz überschreiben. */\n.cm-block .cm-editor,\n.cm-block .cm-scroller,\n.cm-block .cm-gutters { background-color: #000000; }\n/* etwas Luft am unteren Rand, damit die letzte Zeile nicht an der Rundung klebt */\n.cm-block .cm-content { padding-bottom: .6rem; }\n.cm-block .cm-gutters { padding-bottom: .6rem; }\n\n/* Inline-Code: klickbar → Inhalt in die Zwischenablage */\n.msg-body code.md-inline-code {\n    cursor: pointer;\n    transition: background-color .12s ease;\n}\n.msg-body code.md-inline-code:hover { background: rgba(127, 127, 127, .26); }\n.msg-body code.md-inline-code--copied {\n    background: rgba(34, 197, 94, .22);\n    color: #86efac;\n}\n\n/* blockquote */\n.msg-body blockquote {\n    margin: .5em 0;\n    padding: .2em .9em;\n    border-left: 3px solid rgba(127, 127, 127, .35);\n    color: var(--t2, inherit);\n}\n\n/* horizontal rule */\n.msg-body hr {\n    border: none;\n    border-top: 1px solid rgba(127, 127, 127, .3);\n    margin: 1em 0;\n}\n\n/* tables (GFM) — Prose-UI-Stil: kein Außenrahmen, kein Header-Hintergrund,\n   nur horizontale Trennlinien */\n.msg-body table {\n    border-collapse: collapse;\n    width: 100%;\n    margin: .85em 0;\n    font-size: .875em;\n    line-height: 1.5;\n}\n.msg-body th, .msg-body td {\n    padding: .5em .8em;\n    text-align: left;\n    vertical-align: top;\n    border-bottom: 1px solid var(--bd);   /* horizontal dividers only */\n}\n.msg-body thead th {\n    color: #fff;\n    font-weight: 600;\n    border-bottom: 1px solid var(--bd2);\n}\n.msg-body tbody tr:last-child td { border-bottom: none; }\n.msg-body tbody tr:hover { background: rgba(255, 255, 255, .03); }\n\n/* first column kept on one line when all its cells are short (< 10 chars) */\n.msg-body table.md-table--nowrap-1 th:first-child,\n.msg-body table.md-table--nowrap-1 td:first-child { white-space: nowrap; }\n\n/* hover copy-button on tables (rich-text copy).\n   The rail spans the full table height; the button is position:sticky inside it,\n   so it follows the scroll and stays pinned to the top of the visible area until\n   the table itself is (nearly) scrolled out. */\n.md-table-wrap { position: relative; }\n.md-table-rail {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 2px;\n    width: 26px;\n    pointer-events: none;   /* don't block the table; the button re-enables itself */\n}\n.md-table-copy {\n    position: sticky;\n    top: 2px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    padding: 0;\n    border: none;\n    border-radius: 6px;\n    background: var(--g900);\n    color: var(--t2);\n    cursor: pointer;\n    pointer-events: auto;\n    opacity: 0;\n    transition: opacity .12s, background .12s, color .12s;\n}\n.md-table-wrap:hover .md-table-copy,\n.md-table-copy:focus-visible { opacity: 1; }\n.md-table-copy:hover { background: var(--g850); color: var(--t1); }\n.md-table-copy--copied { color: #4ade80; opacity: 1; }\n\n/* GFM task lists */\n.msg-body li input[type=\"checkbox\"] { margin-right: .4em; }\n.msg-body ul:has(> li > input[type=\"checkbox\"]) { list-style: none; padding-left: .25rem; }\n\n/* inline images */\n.msg-body img { max-width: 100%; border-radius: 6px; }\n\n/* inline citation button (replaces [n] when sources are present) */\n.md-citation {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    width: fit-content;\n    vertical-align: text-bottom;\n    -webkit-user-select: none;   /* excluded from text selection / copy (like OWUI) */\n    user-select: none;\n    transform: translateY(2px);\n    margin: 0 1px;\n    padding: 1px 8px 1px 6px;\n    font-size: 10px;\n    line-height: 1.4;\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n    background: rgba(255, 255, 255, .06);\n    color: rgba(255, 255, 255, .8);\n    transition: color .12s, background .12s;\n}\n.md-citation:hover { color: #fff; background: rgba(255, 255, 255, .10); }\n.md-citation__label {\n    white-space: nowrap;   /* label is already truncated to ≤20 chars in JS */\n}\n.md-citation__icon {\n    flex: 0 0 auto;\n    width: 12px;\n    height: 12px;\n    border-radius: 3px;\n}\n.md-citation__icon--doc {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    opacity: .75;\n}\n\n/* ── Thinking / Reasoning block ─────────────────────────── */\n.thinking-block {\n    margin: .25rem 0 .375rem;\n    border-radius: .625rem;\n    border: 1px solid rgba(99, 102, 241, 0.25);\n    background: rgba(99, 102, 241, 0.06);\n    overflow: hidden;\n    width: 100%;\n}\n\n.thinking-block__toggle {\n    display: flex;\n    align-items: center;\n    gap: .4rem;\n    width: 100%;\n    padding: .4rem .625rem;\n    text-align: left;\n    font-size: .8125rem;\n    color: #a5b4fc;  /* indigo-300 */\n    transition: background .12s;\n}\n.thinking-block__toggle:hover { background: rgba(99, 102, 241, 0.1); }\n\n.thinking-block__spinner svg {\n    animation: thinking-spin 1.2s linear infinite;\n    flex: 0 0 auto;\n}\n@keyframes thinking-spin { to { transform: rotate(360deg); } }\n\n.thinking-block__label { flex: 1; font-weight: 500; }\n\n.thinking-block__chevron {\n    flex: 0 0 auto;\n    transition: transform .15s;\n    color: #818cf8;\n}\n.thinking-block__chevron--open { transform: rotate(180deg); }\n\n.thinking-block__content {\n    padding: .375rem .625rem .5rem;\n    border-top: 1px solid rgba(99, 102, 241, 0.15);\n    display: flex;\n    flex-direction: column;\n    gap: .25rem;\n}\n\n/* ── Thinking step items ── */\n.ts-item {\n    display: flex;\n    align-items: flex-start;\n    gap: .5rem;\n    padding: .2rem .25rem;\n    border-radius: .375rem;\n    cursor: default;\n    position: relative;\n}\n.ts-item:hover { background: rgba(255,255,255,.04); }\n\n.ts-item__dot {\n    flex: 0 0 6px;\n    width: 6px; height: 6px;\n    border-radius: 50%;\n    margin-top: .375rem;\n    background: rgba(99,102,241,.5);\n}\n.ts-item--tool    .ts-item__dot { background: #a5b4fc; }\n.ts-item--result  .ts-item__dot { background: rgba(99,102,241,.25); }\n.ts-item--muted   .ts-item__dot { background: var(--t3); }\n.ts-item--reasoning .ts-item__dot { background: rgba(129,140,248,.6); }\n\n.ts-item__text {\n    flex: 1 1 auto;\n    font-size: .7813rem;\n    line-height: 1.5;\n    color: var(--t2);\n    /* max 2 lines, truncated */\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    white-space: normal;\n}\n.ts-item--tool   .ts-item__text { color: #a5b4fc; font-family: ui-monospace, monospace; font-size: .75rem; }\n.ts-item--result .ts-item__text { color: var(--t3); font-size: .75rem; }\n.ts-item--muted  .ts-item__text { color: var(--t3); font-style: italic; }\n\n/* ── Tooltip on hover ── */\n.ts-tooltip {\n    position: fixed;\n    z-index: 9999;\n    max-width: min(22rem, 90vw);\n    padding: .625rem .875rem;\n    border-radius: .625rem;\n    background: var(--g800);\n    border: 1px solid var(--bd2);\n    box-shadow: 0 8px 24px rgba(0,0,0,.5);\n    font-size: .8125rem;\n    color: var(--t1);\n    line-height: 1.55;\n    white-space: pre-wrap;\n    pointer-events: none;\n}\n\n/* ── Action row under assistant message ─────────────────── */\n.msg-actions {\n    display: flex;\n    align-items: center;\n    gap: .125rem;\n    margin-top: .125rem;\n    flex-wrap: wrap;\n}\n\n/* hide action bar on non-last messages, reveal on hover */\n.message--assistant--hoverable .msg-actions {\n    opacity: 0;\n    transition: opacity .15s;\n}\n.message--assistant--hoverable:hover .msg-actions {\n    opacity: 1;\n}\n.msg-action-btn {\n    width: 1.75rem; height: 1.75rem;\n    border-radius: .375rem;\n    display: inline-flex; align-items: center; justify-content: center;\n    color: var(--t3);\n    transition: color .12s, background .12s;\n}\n.msg-action-btn:hover { color: #fff; background: rgba(255,255,255,.06); }\n\n/* ── Web search sources block ───────────────────────────── */\n.sources-block {\n    margin: .375rem 0 .25rem;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: .375rem;\n}\n/* Top row: toggle pill + visibility action — never wraps; the action truncates instead. */\n.sources-block__bar {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: .375rem;\n    min-width: 0;\n}\n.sources-block__bar .sources-block__toggle { flex: 0 0 auto; }\n/* Hover-revealed show/hide-citations action — grows the block when revealed; shrinks\n   (front-truncated) rather than wrapping below the pill when space is tight. */\n.sources-block__visibility {\n    flex: 0 1 auto;\n    min-width: 0;\n    height: 2rem;\n    border-radius: 999px;\n    border: 1px solid var(--bd);\n    background: transparent;\n    font-size: .75rem;\n    font-weight: 500;\n    color: var(--t2);\n    cursor: pointer;\n    /* hidden until the block is hovered */\n    max-width: 0;\n    padding: 0;\n    border-width: 0;\n    opacity: 0;\n    overflow: hidden;\n    transition: max-width .16s ease, opacity .12s ease, padding .16s ease, background .12s, color .12s;\n}\n.sources-block:hover .sources-block__visibility,\n.sources-block__visibility:focus-visible {\n    max-width: 14rem;\n    padding: 0 .875rem;\n    border-width: 1px;\n    opacity: 1;\n}\n.sources-block__visibility:hover { background: rgba(255,255,255,.06); color: var(--t1); }\n/* Front truncation: clip the start so the verb (\"…anzeigen\"/\"…verstecken\") stays\n   visible. RTL block = left-side ellipsis; the text is isolated as a single LTR run\n   (<bdi>) so the word order is preserved (no reordering). */\n.sources-block__visibility-label {\n    display: block;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    direction: rtl;\n}\n.sources-block__visibility-text {\n    unicode-bidi: isolate;\n    direction: ltr;\n}\n/* red \"!\" after the word \"Quellen\" when citations are hidden */\n.sources-block__alert {\n    margin-left: .3rem;\n    color: #f87171;\n    font-weight: 700;\n}\n/* hidden inline citations in the message body */\n.msg-body--citations-hidden .md-citation { display: none; }\n\n/* pill button: stacked favicons + \"+N\" + count */\n.sources-block__toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: .375rem;\n    height: 2rem;\n    padding: 0 .875rem;\n    border-radius: 999px;\n    border: 1px solid var(--bd);\n    background: transparent;\n    font-size: .75rem;\n    font-weight: 500;\n    color: var(--t2);\n    transition: background .12s, color .12s;\n}\n.sources-block__toggle:hover { background: rgba(255,255,255,.06); color: var(--t1); }\n\n.sources-block__favicons {\n    display: inline-flex;\n    align-items: center;\n}\n.sources-block__favicons > * + * { margin-left: -4px; }\n.sources-block__favicon {\n    width: 16px;\n    height: 16px;\n    border-radius: 999px;\n    flex: 0 0 auto;\n    border: 1px solid var(--g900);\n    background: transparent;\n}\n.sources-block__more {\n    width: 16px;\n    height: 16px;\n    border-radius: 999px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 8px;\n    font-weight: 600;\n    letter-spacing: -.03em;\n    color: var(--t2);\n    background: var(--g800);\n    border: 1px solid var(--g900);\n}\n\n.sources-block__list {\n    flex-basis: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: .375rem;\n    padding: .375rem 0;\n}\n.sources-block__item {\n    display: flex;\n    align-items: center;\n    gap: .375rem;\n    text-decoration: none;\n    min-width: 0;\n    color: var(--t2);\n}\n.sources-block__index {\n    flex: 0 0 auto;\n    box-sizing: border-box;\n    min-width: 1.35rem;\n    text-align: center;\n    font-weight: 500;\n    font-size: .6875rem;\n    color: var(--t2);\n    background: var(--g850);\n    border-radius: .375rem;\n    padding: 0 .35rem;\n    line-height: 1.4;\n}\n.sources-block__url {\n    flex: 1 1 auto;\n    font-size: .75rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: left;\n    transition: color .12s;\n}\n.sources-block__item:hover .sources-block__url { color: #fff; }\n/* Knowledge-file sources use a file icon instead of a favicon (collapsed strip). */\n.sources-block__favicon--icon {\n    border: none;\n    border-radius: 0;\n    background: transparent;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--t2);\n}\n.sources-block__favicon--icon svg { display: block; }\n/* Leading icon in each expanded list item (favicon for web, file icon for knowledge).\n   Fixed 16×16 box so the icon + text columns line up across rows. */\n.sources-block__item-icon {\n    flex: 0 0 auto;\n    box-sizing: border-box;\n    width: 16px;\n    height: 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--t3);\n}\n.sources-block__item-icon svg { display: block; }\n.sources-block__item-favicon {\n    box-sizing: border-box;\n    border-radius: 999px;\n    border: 1px solid var(--g900);\n    background: transparent;\n}\n.sources-block__item--file { cursor: default; }\n\n/* active web-search chip in the composer toolbar (sky accent, ✕ on hover) */\n.web-search-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: .375rem;\n    padding: 7px;\n    border-radius: 999px;\n    cursor: pointer;\n    transition: background-color .3s, color .3s;\n    color: #7dd3fc;                          /* sky-300 */\n    background: rgba(56, 163, 248, .10);     /* sky-400/10 */\n    border: 1px solid rgba(14, 165, 233, .20); /* sky-500/20 */\n}\n.web-search-chip:hover { background: rgba(2, 132, 199, .14); } /* sky-600/~ */\n.web-search-chip__globe { flex: 0 0 auto; }\n.web-search-chip__x {\n    display: none;\n    align-items: center;\n    flex: 0 0 auto;\n}\n.web-search-chip:hover .web-search-chip__x { display: inline-flex; }\n\n/* fork / branch switcher (‹ 1/2 ›) under a forked message */\n.branch-switcher {\n    display: inline-flex;\n    align-items: center;\n    gap: .125rem;\n    align-self: flex-start;\n    margin-top: .25rem;\n    color: var(--t2);\n}\n/* under a user message: right-aligned */\n.message--user .branch-switcher { align-self: flex-end; margin-left: auto; }\n\n/* footer row under a user message: switcher + hover edit action, right-aligned */\n.msg-user-footer {\n    display: flex;\n    align-items: center;\n    gap: .25rem;\n    align-self: flex-end;\n    margin-top: .125rem;\n}\n.msg-user-footer .branch-switcher { margin-top: 0; margin-left: 0; }\n.msg-user-actions {\n    display: inline-flex;\n    align-items: center;\n    opacity: 0;\n    transition: opacity .12s;\n}\n.message--user:hover .msg-user-actions,\n.msg-user-actions:focus-within { opacity: 1; }\n\n/* inline edit composer (replaces a user message while editing) */\n.edit-composer {\n    width: 100%;\n    background: var(--g850);\n    border: 1px solid var(--bd);\n    border-radius: var(--r2xl, 1rem);\n    padding: .75rem .875rem;\n    display: flex;\n    flex-direction: column;\n    gap: .75rem;\n}\n.edit-composer__textarea {\n    width: 100%;\n    resize: none;\n    border: none;\n    outline: none;\n    background: transparent;\n    color: var(--t1);\n    font: inherit;\n    font-size: .9375rem;\n    line-height: 1.5;\n}\n.edit-composer__actions {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: .5rem;\n}\n.edit-composer__right { display: flex; gap: .5rem; }\n.edit-composer__btn {\n    height: 2rem;\n    padding: 0 1rem;\n    border-radius: 999px;\n    font-size: .8125rem;\n    font-weight: 500;\n    cursor: pointer;\n    border: 1px solid transparent;\n    transition: background .12s, color .12s, filter .12s;\n}\n.edit-composer__btn--ghost { background: transparent; border-color: var(--bd2); color: var(--t1); }\n.edit-composer__btn--ghost:hover { background: rgba(255, 255, 255, .06); }\n.edit-composer__btn--dark { background: var(--g950); color: #fff; }\n.edit-composer__btn--dark:hover { background: #000; }\n.edit-composer__btn--primary { background: #fff; color: #111; }\n.edit-composer__btn--primary:hover { filter: brightness(.92); }\n.branch-switcher__btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.75rem;\n    height: 1.75rem;\n    padding: 0;\n    border: none;\n    background: transparent;\n    color: inherit;\n    border-radius: .375rem;\n    cursor: pointer;\n    transition: background .12s, color .12s;\n}\n.branch-switcher__btn:hover:not(:disabled) { background: rgba(255, 255, 255, .08); color: #fff; }\n.branch-switcher__btn:disabled { opacity: .35; cursor: default; }\n.branch-switcher__count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    height: 1.75rem;\n    font-size: .75rem;\n    letter-spacing: .08em;\n    font-weight: 600;\n    color: var(--t1);\n    min-width: fit-content;\n    padding: 0 .125rem;\n}\n\n/* ── Modal dialog (reusable) ────────────────────────────── */\n.modal-overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1.25rem;\n    background: rgba(0, 0, 0, .72);   /* strong dim */\n    backdrop-filter: blur(2px);\n}\n.modal {\n    width: 100%;\n    max-width: 28rem;\n    background: var(--g900);\n    border: 1px solid var(--bd2);\n    border-radius: var(--r2xl, 1rem);\n    padding: 1.25rem;\n    box-shadow: 0 20px 50px rgba(0, 0, 0, .5);\n}\n.modal__body {\n    display: flex;\n    align-items: flex-start;\n    gap: 1rem;\n}\n.modal__icon {\n    flex: 0 0 auto;\n    width: 64px;\n    height: 64px;\n    margin-top: .5rem;   /* half the .modal__body gap */\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--t2);\n}\n.modal__icon svg { width: 64px; height: 64px; }\n.modal__title {\n    margin: .1rem 0 .4rem;\n    font-size: 1.0625rem;\n    font-weight: 600;\n    color: var(--t1);\n}\n.modal__message {\n    margin: 0;\n    font-size: .9375rem;\n    line-height: 1.5;\n    color: var(--t2);\n}\n.modal__actions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: .5rem;\n    margin-top: 1.25rem;\n}\n.modal__btn {\n    height: 2.25rem;\n    padding: 0 1.1rem;\n    border-radius: 999px;\n    font-size: .875rem;\n    font-weight: 500;\n    cursor: pointer;\n    border: 1px solid transparent;\n    transition: background .12s, color .12s, filter .12s;\n}\n.modal__btn--left { margin-right: auto; }\n.modal__btn--grey { background: var(--g800); color: var(--t1); }\n.modal__btn--grey:hover { background: var(--g850); }\n.modal__btn--danger { background: #dc2626; color: #fff; }\n.modal__btn--danger:hover { filter: brightness(1.08); }\n.modal__btn--primary { background: #fff; color: #111; }\n.modal__btn--primary:hover { filter: brightness(.92); }\n\n/* ── Follow-up questions block ──────────────────────────── */\n.followups {\n    margin-top: .75rem;\n    display: flex;\n    flex-direction: column;\n    gap: .25rem;\n}\n.followups__label {\n    font-size: .75rem;\n    font-weight: 600;\n    color: var(--t2);\n    margin-bottom: .25rem;\n    letter-spacing: .03em;\n}\n.followup-btn {\n    display: block;\n    text-align: left;\n    font-size: .875rem;       /* text-sm */\n    color: var(--sky);        /* text-sky-500 */\n    line-height: 1.5;\n    padding: .125rem 0;\n    background: none;\n    border: none;\n    cursor: pointer;\n    transition: opacity .12s;\n}\n.followup-btn:hover { opacity: .75; }\n\n/* ── Typing indicator ───────────────────────────────────── */\n.typing-dots { display: inline-flex; align-items: center; gap: .3rem; padding: .2rem 0; }\n.typing-dot {\n    width: 5px; height: 5px;\n    border-radius: 50%;\n    background: var(--t3);\n    animation: dot-pulse 1.4s infinite ease-in-out;\n}\n.typing-dot:nth-child(2) { animation-delay: .2s; }\n.typing-dot:nth-child(3) { animation-delay: .4s; }\n@keyframes dot-pulse {\n    0%,60%,100% { opacity: .3; transform: scale(.8); }\n    30%         { opacity: 1;  transform: scale(1);  }\n}\n\n/* ── Quick actions — flex, centered, top-aligned ────────── */\n.quick-actions {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    padding: 1.5rem 1rem .5rem;\n    overflow-y: auto;\n}\n.quick-actions__grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: .5rem;\n    justify-content: center;\n    align-content: flex-start;\n    max-width: 26rem;\n    width: 100%;\n}\n.quick-actions__btn {\n    display: flex; flex-direction: column; align-items: flex-start;\n    gap: .2rem; padding: .625rem .875rem;\n    border-radius: var(--r2xl);\n    border: 1px solid var(--bd2);\n    background: var(--g850);\n    text-align: left;\n    transition: background .12s, border-color .12s;\n    min-width: 8rem; max-width: 14rem; flex: 1 1 8rem;\n}\n.quick-actions__btn:hover { background: var(--g800); border-color: rgba(255,255,255,.2); }\n.quick-actions__title { font-size: .8125rem; font-weight: 500; color: var(--t1); line-height: 1.3; }\n.quick-actions__sub {\n    font-size: .6875rem; color: var(--t3); line-height: 1.4;\n    display: -webkit-box; -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical; overflow: hidden;\n}\n\n/* ── Composer ───────────────────────────────────────────── */\n.composer { flex: 0 0 auto; padding: .5rem 1rem .875rem; }\n\n/* Hero state: model info centered above input */\n.composer--hero {\n    display: flex; flex-direction: column;\n    align-items: center; gap: 1rem;\n    padding: .75rem 1rem 1.25rem;\n}\n.composer__hero {\n    display: flex; flex-direction: column;\n    align-items: center; gap: .3rem;\n    text-align: center;\n}\n.composer__model-icon {\n    width: 5.25rem; height: 5.25rem;\n    border-radius: 1.25rem; overflow: hidden;\n    display: inline-flex; align-items: center; justify-content: center;\n    background: none;\n    margin-bottom: .3rem; flex: 0 0 auto;\n}\n.composer__model-icon img { width: 100%; height: 100%; object-fit: contain; }\n.composer__model-name {\n    margin: 0; font-size: 1.25rem; font-weight: 600;\n    color: var(--t1); line-height: 1.15;\n}\n.composer__model-desc {\n    margin: 0; font-size: .8125rem; color: var(--t2);\n    line-height: 1.5; max-width: 22rem;\n}\n\n/* Input box (shared between hero and chat state) */\n.composer__box {\n    width: 100%;\n    background: var(--g850);\n    border: 1px solid var(--bd);\n    border-radius: var(--r3xl);    /* 1.5rem — matches OpenWebUI */\n    padding: .75rem 1rem .625rem;\n    display: flex; flex-direction: column; gap: .5rem;\n    transition: border-color .15s;\n}\n.composer__box--active,\n.composer__box:focus-within { border-color: var(--bd2); }\n\n.composer__textarea {\n    width: 100%;\n    min-height: 1.5rem; max-height: 33vh;\n    resize: none; border: none; outline: none;\n    background: transparent;\n    color: var(--t1);\n    font-size: .9375rem;\n    line-height: 1.6;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255,255,255,.08) transparent;\n}\n.composer__textarea::placeholder { color: var(--t3); }\n\n.composer__toolbar {\n    display: flex; align-items: center;\n    justify-content: space-between; gap: .375rem;\n}\n.composer__toolbar-left { display: flex; align-items: center; gap: .125rem; }\n.composer__toolbar-right { display: flex; align-items: center; gap: .5rem; }\n\n/* separator line between left groups */\n.composer__sep {\n    width: 1px; height: 1rem;\n    background: var(--bd2);\n    margin: 0 .25rem;\n    flex: 0 0 auto;\n}\n\n.composer__tools-count {\n    font-size: .6875rem; font-weight: 600;\n    background: rgba(255,255,255,.1);\n    padding: .1rem .35rem; border-radius: .3rem; line-height: 1.3;\n}\n\n/* mic button — same size as send, filled icon */\n.composer__mic {\n    width: 1.875rem; height: 1.875rem;\n    border-radius: 999px;\n    display: inline-flex; align-items: center; justify-content: center;\n    background: rgba(255,255,255,.08);\n    color: var(--t2);\n    transition: background .15s, color .15s; flex: 0 0 auto;\n}\n.composer__mic:hover { background: rgba(255,255,255,.14); color: var(--t1); }\n\n.composer__send {\n    width: 1.875rem; height: 1.875rem;\n    border-radius: 999px;\n    display: inline-flex; align-items: center; justify-content: center;\n    background: var(--t1); color: var(--g950);\n    transition: opacity .15s, background .15s; flex: 0 0 auto;\n}\n.composer__send:disabled { opacity: .2; cursor: not-allowed; }\n.composer__send:not(:disabled):hover { background: #e5e5e5; }\n\n.composer__stop {\n    width: 1.875rem; height: 1.875rem;\n    border-radius: 999px;\n    display: inline-flex; align-items: center; justify-content: center;\n    background: rgba(239, 68, 68, 0.15);\n    color: #f87171;\n    border: 1px solid rgba(239, 68, 68, 0.3);\n    transition: background .15s; flex: 0 0 auto;\n}\n.composer__stop:hover { background: rgba(239, 68, 68, 0.28); }\n\n/* Aborted message badge */\n.msg-aborted {\n    display: inline-flex;\n    align-items: center;\n    gap: .375rem;\n    padding: .3rem .75rem;\n    border-radius: .5rem;\n    background: rgba(239, 68, 68, 0.08);\n    border: 1px solid rgba(239, 68, 68, 0.2);\n    color: #f87171;\n    font-size: .8125rem;\n    margin-top: .125rem;\n}\n\n/* ── File chips strip ───────────────────────────────────── */\n.composer__files {\n    display: flex;\n    flex-wrap: wrap;\n    gap: .375rem;\n    padding-bottom: .25rem;\n}\n.file-chip {\n    position: relative;\n    display: inline-flex; align-items: center; gap: .375rem;\n    padding: .3rem .625rem;\n    border-radius: .625rem;\n    background: var(--g800);\n    border: 1px solid var(--bd2);\n    max-width: 10rem;\n    cursor: default;\n}\n.file-chip__icon { flex: 0 0 auto; color: var(--t3); }\n.file-chip__name {\n    font-size: .75rem; font-weight: 500; color: var(--t1);\n    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n    max-width: 4rem;\n}\n.file-chip__size { font-size: .6875rem; color: var(--t3); white-space: nowrap; }\n.file-chip__remove {\n    position: absolute;\n    top: -.4rem; right: -.4rem;\n    width: 1rem; height: 1rem;\n    border-radius: 999px;\n    background: #f5f5f5;\n    border: none;\n    color: var(--g900);\n    display: none;\n    align-items: center; justify-content: center;\n    line-height: 1;\n}\n.file-chip:hover .file-chip__remove { display: inline-flex; }\n.file-chip__remove:hover { background: #ffffff; }\n\n/* Multiple attachments stack vertically (untereinander), right-aligned. */\n.message--user .msg-files--attachments {\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n/* Attachment chips pinned to a user message mirror the user bubble (bg + colors + padding).\n   All chips share a fixed 240px width; the name truncates, full name in the tooltip. */\n.message--user .file-chip {\n    box-sizing: border-box;\n    flex: 0 0 auto;           /* don't shrink to content in the column stack */\n    width: 240px;\n    max-width: 240px;         /* override the base .file-chip max-width: 10rem */\n    background: var(--g850);\n    border: none;\n    border-radius: var(--r3xl);\n    padding: .5rem 1.25rem;   /* match the bubble's py-2 px-5 */\n}\n.message--user .file-chip__name {\n    flex: 1 1 auto;\n    min-width: 0;\n    max-width: none;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.message--user .file-chip__size { flex: 0 0 auto; }\n.message--user .file-chip__icon {\n    color: #fff;\n    display: inline-flex;\n    align-items: center;\n    line-height: 1;\n}\n.message--user .file-chip__icon svg { display: block; }\n\n/* Pointed corners build a connected stack toward the bubble:\n   first attachment → bottom-right; all further → top-right + bottom-right. */\n.message--user .file-chip:first-child {\n    border-radius: var(--r3xl) var(--r3xl) .375rem var(--r3xl);\n}\n.message--user .file-chip:not(:first-child) {\n    border-radius: var(--r3xl) .375rem .375rem var(--r3xl);\n}\n\n/* When attachments sit above the bubble, the pointed corner moves to the\n   top-right (toward the attachments) instead of the bottom-right. */\n.message--user .msg-bubble--attached {\n    border-radius: var(--r3xl) .375rem var(--r3xl) var(--r3xl);\n}\n\n/* ── Attach / Tools dropdown ────────────────────────────── */\n.c-popover { position: relative; }\n\n.c-dropdown {\n    position: absolute;\n    bottom: calc(100% + .375rem);\n    left: 0;\n    z-index: 200;\n    min-width: 13rem;\n    background: var(--g850);\n    border: 1px solid var(--bd2);\n    border-radius: var(--r2xl);\n    box-shadow: 0 8px 24px rgba(0,0,0,.5);\n    overflow: hidden;\n    padding: .375rem;\n    display: flex; flex-direction: column; gap: .125rem;\n}\n\n.c-dropdown__header {\n    display: flex; align-items: center; gap: .5rem;\n    padding: .5rem .625rem;\n    border-radius: .5rem;\n    font-size: .875rem; font-weight: 600; color: var(--t1);\n    border-bottom: 1px solid var(--bd);\n    margin-bottom: .125rem;\n}\n.c-dropdown__header-label { display: flex; align-items: center; gap: .375rem; flex: 1; }\n.c-dropdown__header-count {\n    font-size: .75rem; font-weight: 600;\n    color: var(--t3);\n    background: rgba(255,255,255,.08);\n    padding: .1rem .35rem; border-radius: .3rem;\n}\n\n.c-dropdown__item {\n    display: flex; align-items: center; gap: .625rem;\n    width: 100%; padding: .5rem .625rem;\n    border-radius: .5rem;\n    text-align: left; font-size: .875rem; color: var(--t1);\n    transition: background .1s;\n}\n.c-dropdown__item:hover { background: rgba(255,255,255,.07); }\n.c-dropdown__item--tool { justify-content: space-between; }\n.c-dropdown__tool-icon { flex: 0 0 auto; color: var(--t3); }\n.c-dropdown__item-label { flex: 1; }\n.c-dropdown__item-arrow { flex: 0 0 auto; color: var(--t3); }\n\n/* toggle switch */\n.c-toggle {\n    width: 2.125rem; height: 1.125rem;\n    border-radius: 999px;\n    background: var(--bd2);\n    position: relative;\n    flex: 0 0 auto;\n    transition: background .2s;\n}\n.c-toggle--on { background: var(--t1); }\n.c-toggle__knob {\n    position: absolute;\n    top: .15rem; left: .15rem;\n    width: .825rem; height: .825rem;\n    border-radius: 999px;\n    background: var(--g900);\n    transition: transform .2s;\n}\n.c-toggle--on .c-toggle__knob { transform: translateX(1rem); }\n\n/* ── Voice recorder — single row ────────────────────────── */\n.voice-recorder {\n    width: 100%;\n    background: var(--g850);\n    border: 1px solid var(--bd2);\n    border-radius: var(--r3xl);\n    padding: .5rem .75rem;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: .625rem;\n    height: 2.75rem;     /* same height as the composer box toolbar row */\n}\n\n/* Visualizer — fills all remaining space */\n.voice-viz {\n    flex: 1 1 auto;\n    min-width: 0;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n}\n\n.voice-viz__bars {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 2px;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n}\n\n.voice-viz__bar {\n    flex: 0 0 2px;\n    width: 2px;\n    border-radius: 999px;\n    background: #6366f1;\n    transition: height .08s ease-out;\n}\n\n/* Cancel button */\n.voice-controls__cancel {\n    width: 1.875rem; height: 1.875rem;\n    border-radius: 999px;\n    display: inline-flex; align-items: center; justify-content: center;\n    background: rgba(255,255,255,.08);\n    color: var(--t2);\n    transition: background .12s, color .12s;\n    flex: 0 0 auto;\n}\n.voice-controls__cancel:hover { background: rgba(255,255,255,.15); color: var(--t1); }\n\n/* Timer */\n.voice-controls__timer {\n    font-size: .875rem;\n    font-weight: 600;\n    color: #818cf8;\n    letter-spacing: .04em;\n    flex: 0 0 auto;\n    white-space: nowrap;\n}\n.voice-controls__timer--loading { color: var(--t3); }\n\n/* Spinner */\n.voice-controls__spinner { color: var(--t3); flex: 0 0 auto; display: inline-flex; }\n\n/* Confirm button */\n.voice-controls__confirm {\n    width: 1.875rem; height: 1.875rem;\n    border-radius: 999px;\n    display: inline-flex; align-items: center; justify-content: center;\n    background: #6366f1;\n    color: #fff;\n    transition: background .12s;\n    flex: 0 0 auto;\n}\n.voice-controls__confirm:hover { background: #4f46e5; }\n\n/* ── Loading screen ─────────────────────────────────────── */\n.taskpane-app--loading { align-items: center; justify-content: center; }\n.loading-card {\n    width: min(100%, 22rem); padding: 2rem 1.5rem;\n    border-radius: var(--r4xl); background: var(--g850);\n    border: 1px solid var(--bd2); text-align: center;\n}\n.loading-card__logo { width: 3.5rem; height: 3.5rem; object-fit: contain; border-radius: 1rem; }\n.loading-card__eyebrow { margin-top: .875rem; font-size: .6875rem; color: var(--t3); text-transform: uppercase; letter-spacing: .08em; }\n.loading-card__title { margin: .4rem 0 .3rem; font-size: 1.15rem; font-weight: 600; }\n.loading-card__message { margin: 0 0 1.125rem; font-size: .875rem; color: var(--t2); line-height: 1.5; }\n.loading-card__bar { width: 100%; height: 3px; border-radius: 999px; background: var(--bd2); overflow: hidden; }\n.loading-card__bar-fill { display: block; height: 100%; border-radius: inherit; background: var(--acc); animation: bar-slide 1.6s infinite ease-in-out; }\n@keyframes bar-slide {\n    0%   { transform: translateX(-100%) scaleX(.5); }\n    50%  { transform: translateX(30%)   scaleX(1.2); }\n    100% { transform: translateX(220%)  scaleX(.5); }\n}\n\n/* ── Body layout: main content + (optional) chat-history sidebar ─────────── */\n.taskpane-body {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    position: relative;\n}\n.taskpane-main {\n    flex: 1 1 auto;\n    min-width: 0;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Chat-history sidebar (right). Docked → in-flow column beside content;\n   overlay → absolute over content with a backdrop. Always 260px wide. */\n.chat-history {\n    width: 260px;\n    background: #0f0f0f;\n    border-left: 1px solid var(--bd2);\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n.chat-history--docked { flex: 0 0 260px; }\n.chat-history--overlay {\n    position: absolute;\n    top: 0; right: 0; bottom: 0;\n    z-index: 30;\n    box-shadow: -8px 0 24px rgba(0,0,0,.45);\n}\n.chat-history__backdrop {\n    position: absolute;\n    inset: 0;\n    background: rgba(0,0,0,.45);\n    z-index: 20;\n}\n\n.chat-history__header {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: .625rem .75rem .5rem;\n}\n.chat-history__title { font-size: .8125rem; font-weight: 600; color: var(--t1); }\n/* Reserved slot for future menu items (e.g. chat search). */\n.chat-history__menu { flex: 0 0 auto; }\n\n.chat-history__body {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    padding: .25rem .5rem .75rem;\n}\n.chat-history__body::-webkit-scrollbar       { width: .3rem; }\n.chat-history__body::-webkit-scrollbar-thumb { background: rgba(255,255,255,.1); border-radius: 999px; }\n\n.chat-history__section { margin-bottom: .5rem; }\n.chat-history__section-toggle {\n    display: flex;\n    align-items: center;\n    gap: .375rem;\n    width: 100%;\n    padding: .375rem .5rem;\n    background: transparent;\n    border: none;\n    border-radius: .5rem;\n    color: var(--t2);\n    font-size: .75rem;\n    font-weight: 600;\n    letter-spacing: .02em;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.chat-history__section-toggle:hover { background: rgba(255,255,255,.06); color: var(--t1); }\n.chat-history__chevron { flex: 0 0 auto; transition: transform .12s ease; }\n.chat-history__chevron--open { transform: rotate(90deg); }\n\n.chat-history__group { margin: .25rem 0 .5rem; }\n.chat-history__group-label {\n    font-size: .6875rem;\n    font-weight: 600;\n    color: var(--t3);\n    padding: .25rem .5rem .125rem;\n}\n.chat-history__item {\n    display: flex;\n    align-items: center;\n    gap: .375rem;\n    width: 100%;\n    text-align: left;\n    padding: .4rem .5rem;\n    border: none;\n    border-radius: .5rem;\n    background: transparent;\n    color: var(--t1);\n    font-size: .8125rem;\n    cursor: pointer;\n}\n.chat-history__item-title {\n    flex: 1 1 auto;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n/* Age pill (last change): same colour as the sidebar background, subtle. */\n.chat-history__item-age {\n    flex: 0 0 auto;\n    background: #0f0f0f;\n    color: var(--t3);\n    font-size: .6875rem;\n    line-height: 1;\n    padding: .15rem .4rem;\n    border-radius: 999px;\n}\n.chat-history__item:hover { background: rgba(255,255,255,.06); }\n.chat-history__item--active { background: rgba(255,255,255,.10); font-weight: 500; }\n.chat-history__empty { padding: .5rem; font-size: .75rem; color: var(--t3); }\n.chat-history__empty--error { color: #f87171; }\n\n.icon-btn--active { background: rgba(255,255,255,.10); color: var(--t1); }\n\n/* Projekte (folder tree) inside the history sidebar */\n.chat-history__folder-row {\n    display: flex;\n    align-items: center;\n    gap: .375rem;\n    width: 100%;\n    padding: .375rem .5rem;\n    background: transparent;\n    border: none;\n    border-radius: .5rem;\n    color: var(--t1);\n    font-size: .8125rem;\n    cursor: pointer;\n    text-align: left;\n}\n.chat-history__folder-row:hover { background: rgba(255,255,255,.06); }\n.chat-history__folder-icon { flex: 0 0 auto; color: var(--t3); }\n.chat-history__folder-name {\n    flex: 1 1 auto;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.chat-history__folder-children { /* indentation handled inline per depth */ }\n\n/* Section header row: collapsible toggle + hover \"+\" */\n.chat-history__section-head { display: flex; align-items: center; }\n.chat-history__section-head .chat-history__section-toggle { flex: 1 1 auto; }\n.chat-history__section-add,\n.chat-history__folder-add {\n    flex: 0 0 auto;\n    display: inline-flex; align-items: center; justify-content: center;\n    width: 1.5rem; height: 1.5rem;\n    border: none; border-radius: .375rem;\n    background: transparent; color: var(--t2);\n    cursor: pointer;\n    opacity: 0; transition: opacity .12s, background .12s, color .12s;\n}\n.chat-history__section-head:hover .chat-history__section-add,\n.chat-history__folder-row:hover .chat-history__folder-add { opacity: 1; }\n.chat-history__section-add:hover,\n.chat-history__folder-add:hover { background: rgba(255,255,255,.10); color: var(--t1); }\n\n/* Folder row split into twirl / open / add */\n.chat-history__folder-row { display: flex; align-items: center; gap: .25rem; padding-right: .25rem; }\n.chat-history__folder-twirl {\n    flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;\n    width: 1.1rem; height: 1.5rem; padding: 0;\n    background: transparent; border: none; color: var(--t2); cursor: pointer;\n}\n.chat-history__folder-open {\n    flex: 1 1 auto; min-width: 0;\n    display: flex; align-items: center; gap: .375rem;\n    padding: .375rem .25rem;\n    background: transparent; border: none; border-radius: .5rem;\n    color: var(--t1); font-size: .8125rem; cursor: pointer; text-align: left;\n}\n.chat-history__folder-open:hover { background: rgba(255,255,255,.06); }\n\n/* Active project breadcrumb chip in the topbar (greyed, ✕ on hover) */\n.project-chip {\n    display: inline-flex; align-items: center; gap: .25rem;\n    max-width: 11rem;\n    padding: .2rem .5rem;\n    border-radius: 999px;\n    background: var(--g800);\n    color: var(--t3);\n    font-size: .75rem;\n}\n.project-chip__label { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.project-chip__remove {\n    flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;\n    width: 1rem; height: 1rem; padding: 0;\n    border: none; border-radius: 999px; background: transparent; color: var(--t3);\n    cursor: pointer; opacity: 0; transition: opacity .12s, color .12s;\n}\n.project-chip:hover .project-chip__remove { opacity: 1; }\n.project-chip__remove:hover { color: #fff; }\n\n/* Create-project modal (scoped inside the sidebar) */\n.chat-history__create-overlay {\n    position: absolute; inset: 0; z-index: 40;\n    display: flex; align-items: flex-start; justify-content: center;\n    padding-top: 3rem;\n    background: rgba(0,0,0,.55);\n}\n.chat-history__create {\n    width: 90%; max-width: 240px;\n    background: var(--g850); border: 1px solid var(--bd2); border-radius: .75rem;\n    padding: .875rem; display: flex; flex-direction: column; gap: .5rem;\n}\n.chat-history__create-title { font-size: .8125rem; font-weight: 600; color: var(--t1); }\n.chat-history__create-input {\n    width: 100%; box-sizing: border-box;\n    padding: .45rem .6rem;\n    background: var(--g900); border: 1px solid var(--bd2); border-radius: .5rem;\n    color: var(--t1); font-size: .8125rem;\n}\n.chat-history__create-desc { resize: vertical; font-family: inherit; }\n.chat-history__create-actions { display: flex; justify-content: flex-end; gap: .5rem; }\n.chat-history__btn {\n    padding: .4rem .75rem; border-radius: .5rem; border: 1px solid var(--bd2);\n    background: transparent; color: var(--t1); font-size: .8125rem; cursor: pointer;\n}\n.chat-history__btn--primary { background: #2563eb; border-color: #2563eb; color: #fff; }\n.chat-history__btn:disabled { opacity: .5; cursor: default; }\n\n.chat-history__folder-open--active { background: rgba(255,255,255,.10); font-weight: 500; }\n.project-chip__icon { flex: 0 0 auto; }\n\n/* ── History sidebar: visual refinements (colors, compact rows) ──────────── */\n.chat-history__section-toggle:hover,\n.chat-history__item:hover,\n.chat-history__folder-row:hover { background: #161616; }\n.chat-history__item--active,\n.chat-history__folder-row--active { background: #161616; }\n.chat-history__section-add:hover,\n.chat-history__folder-add:hover { background: #161616; color: var(--t1); }\n\n/* Project/folder rows: single surface, 34px tall, only the twirl reads as a button.\n   The name fills the row and has no separate hover (the row hover covers it). */\n.chat-history__folder-row { height: 34px; padding-top: 0; padding-bottom: 0; border-radius: .5rem; }\n.chat-history__folder-open {\n    background: transparent !important;\n    padding-top: 0; padding-bottom: 0;\n    height: 100%;\n}\n.chat-history__folder-open--active { background: transparent; font-weight: 500; }\n\n/* Indent a folder's contents via the container (not per row), with a thin guide line. */\n.chat-history__folder-children {\n    margin-left: .6rem;\n    padding-left: .35rem;\n    border-left: 1px solid rgba(255,255,255,.07);\n}\n.chat-history__folder-row { padding-left: .25rem; }\n\n/* Drag & drop: a chat being dragged + drop-zone highlight (whole folder block incl. children\n   / the Chats zone) in a very dark grey. */\n.chat-history__item--dragging { opacity: .45; }\n.chat-history__folder--drop,\n.chat-history__chats-zone--drop,\n.chat-history__projects-zone--drop {\n    background: #161616;\n    border-radius: .5rem;\n    box-shadow: inset 0 0 0 1px rgba(255,255,255,.08);\n}\n/* A folder being dragged shows the grab cursor on its name. */\n.chat-history__folder-open[draggable=\"true\"] { cursor: grab; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
